/* vibe-zone-interactive.js — background pulsation, objects, boombox, synth, bug game */
(function () {
  'use strict';

  // ── 1. Animated background canvas (blobs + celestial stars + vibe ripples) ──
  var bgCanvas = document.getElementById('vz-bg');
  var bgCtx = bgCanvas ? bgCanvas.getContext('2d') : null;
  var D2R = Math.PI / 180;

  // Bright named stars [ra_deg, dec_deg, mag]
  var RAW_STARS = [
    [101.3,-16.7,-1.46],[96.0,-52.7,-0.74],[213.9,19.2,-0.05],
    [279.2,38.8,0.03],[79.2,46.0,0.08],[78.6,-8.2,0.12],
    [114.8,5.2,0.38],[24.4,-57.2,0.46],[88.8,7.4,0.50],
    [210.9,-60.4,0.61],[297.7,8.9,0.77],[68.9,16.5,0.85],
    [201.3,-11.2,0.97],[247.4,-26.4,1.06],[116.3,28.0,1.14],
    [344.4,-29.6,1.16],[310.4,45.3,1.25],[191.9,-59.7,1.25],
    [152.1,12.0,1.35],[104.7,-29.0,1.50],[113.6,31.9,1.58],
    [263.4,-37.1,1.62],[187.8,-57.1,1.63],[81.3,6.3,1.64],
    [81.6,28.6,1.65],[138.3,-69.7,1.68],[84.1,-1.2,1.70],
    [85.2,-1.9,1.74],[193.5,56.0,1.76],[51.1,49.9,1.79],
    [165.9,61.8,1.79],[107.1,-26.4,1.83],[276.0,-34.4,1.85],
    [206.9,49.3,1.86],[252.2,-69.0,1.92],[99.4,16.4,1.93],
  ];
  var FAINT_STARS = Array.from({ length: 60 }, function(_, i) {
    return [(i * 137.508) % 360, Math.asin(2 * ((i * 0.618034) % 1) - 1) / D2R, 2.5 + (i % 30) / 12];
  });
  var STAR_3D = RAW_STARS.concat(FAINT_STARS).map(function(s, i) {
    var rr = s[0] * D2R, dr = s[1] * D2R, mag = s[2];
    return {
      x: Math.cos(dr) * Math.cos(rr),
      y: Math.cos(dr) * Math.sin(rr),
      z: Math.sin(dr),
      r: Math.max(0.5, 2.6 - mag * 0.4),
      baseAlpha: Math.max(0.12, Math.min(0.9, 1.05 - mag * 0.18)),
      glow: mag < 1.0,
      phase: i < RAW_STARS.length ? i * 1.618 : i * 0.937,
    };
  });

  // Ripple system (vibe-style halos/flowers/stars)
  var ripples = [];
  var lastRipple = 0;
  var synthVisOn  = false;   // true when vibe synth is active
  var vzDay       = false;   // day/night theme toggle
  var vzDayBeforeGame = null; // theme to restore once buggone closes

  // ── I Ching trigrams (for elemental controls) ─────────────────────────────
  var TRIGRAMS = {
    Qian: [1,1,1], Dui:  [0,1,1], Li:   [1,0,1], Zhen: [0,0,1],
    Xun:  [1,1,0], Kan:  [0,1,0], Gen:  [1,0,0], Kun:  [0,0,0],
  };
  var ELEM_TRIGRAMS = {
    fire:  { base: 'Li',  pair: 'Kan'  },
    wind:  { base: 'Xun', pair: 'Zhen' },
    water: { base: 'Kan', pair: 'Li'   },
    earth: { base: 'Kun', pair: 'Qian' },
  };
  var SOUND_GLOWS = {
    fire: 'rgba(255,102,51,0.4)',   wind:  'rgba(170,221,204,0.4)',
    water:'rgba(68,170,255,0.4)',   earth: 'rgba(204,136,85,0.4)',
    bell: 'rgba(255,209,102,0.4)',  chime: 'rgba(255,232,160,0.4)',
    gong: 'rgba(255,153,68,0.4)',   birds: 'rgba(136,238,136,0.4)',
    white:'rgba(212,212,212,0.4)',  pink:  'rgba(255,126,179,0.4)',
    blue: 'rgba(102,204,255,0.4)',
  };

  // Active sound glow colors — matched to our audio layers
  var GLOW_FIRE  = 'rgba(255,130,40,0.5)';
  var GLOW_RAIN  = 'rgba(100,185,255,0.45)';
  var GLOW_BELL  = 'rgba(255,245,190,0.5)';
  var GLOW_CHIME = 'rgba(210,170,255,0.45)';

  function triggerRipple(glow, shape, petals, points) {
    if (!bgCanvas) return;
    var W = bgCanvas.width, H = bgCanvas.height;
    ripples.push({
      born:     performance.now(),
      glow:     glow,
      maxR:     Math.hypot(W / 2, H / 2) * 1.5,
      speed:    0.45 + Math.random() * 0.4,
      shape:    shape || 'halo',
      petals:   petals || 4,
      points:   points || 5,
      rotation: Math.random() * Math.PI * 2,
      rotSpeed: (Math.random() * 1.4 + 0.4) * (Math.random() < 0.5 ? 1 : -1),
    });
    lastRipple = performance.now();
  }

  function drawHalo(ctx, cx, cy, r, alpha, glow, age) {
    var layers = [
      { dr: 18, w: 20, a: 0.18 },
      { dr:  6, w:  9, a: 0.35 },
      { dr:  0, w:  3, a: 0.75 },
    ];
    layers.forEach(function(l) {
      var la = alpha * l.a;
      if (la < 0.004) return;
      ctx.beginPath();
      ctx.arc(cx, cy, Math.max(1, r + l.dr * (1 - age)), 0, Math.PI * 2);
      ctx.strokeStyle = glow.replace(/[\d.]+\)$/, la.toFixed(3) + ')');
      ctx.lineWidth = l.w * (1 - age * 0.5);
      ctx.stroke();
    });
  }

  function drawFlower(ctx, cx, cy, r, petals, rotation, alpha, glow, age) {
    var steps = 360;
    ctx.beginPath();
    for (var i = 0; i <= steps; i++) {
      var theta = (i / steps) * Math.PI * 2;
      var rr = r * Math.abs(Math.cos((petals / 2) * theta));
      var x = cx + rr * Math.cos(theta + rotation);
      var y = cy + rr * Math.sin(theta + rotation);
      if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
    }
    ctx.strokeStyle = glow.replace(/[\d.]+\)$/, (alpha * 0.82).toFixed(3) + ')');
    ctx.lineWidth = Math.max(0.5, (1 - age) * 2.5);
    ctx.stroke();
  }

  // Color blobs for base atmosphere
  var blobs = [
    { x: 0.22, y: 0.30, r: 0.45, h: 262, s: 75, l: 18, ph: 0,    sp: 0.00022 },
    { x: 0.74, y: 0.60, r: 0.38, h: 185, s: 65, l: 16, ph: 2.1,  sp: 0.00016 },
    { x: 0.50, y: 0.12, r: 0.30, h:  35, s: 70, l: 18, ph: 4.2,  sp: 0.00020 },
    { x: 0.30, y: 0.75, r: 0.33, h: 308, s: 60, l: 15, ph: 1.05, sp: 0.00014 },
    { x: 0.65, y: 0.25, r: 0.25, h: 150, s: 55, l: 14, ph: 3.14, sp: 0.00018 },
  ];

  var bgT = 0;

  function resizeBg() {
    if (!bgCanvas) return;
    bgCanvas.width  = bgCanvas.offsetWidth  || window.innerWidth;
    bgCanvas.height = window.innerHeight;
    bgCanvas.style.height = window.innerHeight + 'px';
  }

  function drawBg(timestamp) {
    if (!bgCtx) return;
    // Pause rendering when tab is hidden — major perf win for background tabs
    if (document.hidden) { requestAnimationFrame(drawBg); return; }
    bgT++;
    var t = timestamp || bgT * 16;
    var W = bgCanvas.width, H = bgCanvas.height;
    var cx = W / 2, cy = H / 2;
    var anyActive = synthVisOn || active.boombox || active.buggone;
    // When idle: render at ~30fps (blobs + stars move slowly enough)
    if (!anyActive && bgT % 2 === 1 && ripples.length === 0) { requestAnimationFrame(drawBg); return; }
    var lBoost = anyActive ? 1.5 : 1.0;

    // ── Update mic energy (boombox→vibe audio routing) ───────────────
    if (micAnalyser && micFData) {
      micAnalyser.getByteFrequencyData(micFData);
      var sum = 0;
      for (var mi = 0; mi < micFData.length; mi++) sum += micFData[mi];
      audioEnergy = sum / micFData.length / 255;

      // Music-reactive: spawn ripples proportional to energy peaks
      var now2 = performance.now();
      var minInterval = Math.max(500, 3000 - audioEnergy * 2500);
      if (audioEnergy > 0.04 && (now2 - lastRipple) > minInterval) {
        var musicGlows = [GLOW_FIRE, GLOW_RAIN, GLOW_BELL, GLOW_CHIME];
        var musicShapes = ['halo', 'flower'];
        triggerRipple(
          musicGlows[Math.floor(Math.random() * musicGlows.length)],
          musicShapes[Math.floor(Math.random() * musicShapes.length)],
          Math.floor(3 + Math.random() * 4),
          Math.floor(4 + Math.random() * 5)
        );
      }
    }

    if (vzDay) {
      // Day sky — warm light gradient
      var skyGrad = bgCtx.createLinearGradient(0, 0, 0, H);
      skyGrad.addColorStop(0,   'rgb(180, 220, 245)');
      skyGrad.addColorStop(0.6, 'rgb(220, 238, 252)');
      skyGrad.addColorStop(1,   'rgb(245, 240, 220)');
      bgCtx.fillStyle = skyGrad;
    } else {
      bgCtx.fillStyle = '#010206';
    }
    bgCtx.fillRect(0, 0, W, H);

    // ── Blob atmosphere ──────────────────────────────────────────────
    var energyBoost = 1 + audioEnergy * 2;
    blobs.forEach(function (b) {
      var x = (b.x + Math.sin(bgT * b.sp + b.ph) * 0.13) * W;
      var y = (b.y + Math.cos(bgT * b.sp * 0.73 + b.ph) * 0.10) * H;
      var r = b.r * Math.min(W, H) * (0.92 + Math.sin(bgT * b.sp * 2.1 + b.ph) * 0.08);
      var hue = b.h + Math.sin(bgT * b.sp * 0.5) * 18;
      var lit, alpha;
      if (vzDay) {
        // Softer, lighter pastel blobs for daytime
        lit   = (b.l * 4.5 + Math.sin(bgT * b.sp * 3.2 + b.ph) * 4) * lBoost;
        alpha = anyActive ? Math.min(0.45, 0.25 + audioEnergy * 0.2) : 0.18;
      } else {
        lit   = (b.l + Math.sin(bgT * b.sp * 3.2 + b.ph) * 3) * lBoost * energyBoost;
        alpha = anyActive ? Math.min(0.85, 0.65 + audioEnergy * 0.3) : 0.45;
      }

      var g = bgCtx.createRadialGradient(x, y, 0, x, y, r);
      g.addColorStop(0,   'hsla(' + hue + ',' + b.s + '%,' + lit + '%,' + alpha + ')');
      g.addColorStop(0.5, 'hsla(' + hue + ',' + b.s + '%,' + (lit - 5) + '%,0.18)');
      g.addColorStop(1,   'hsla(' + hue + ',40%,' + (vzDay ? '60' : '8') + '%,0)');

      bgCtx.fillStyle = g;
      bgCtx.beginPath();
      bgCtx.arc(x, y, r, 0, Math.PI * 2);
      bgCtx.fill();
    });

    // ── Vibe synth color wash ────────────────────────────────────────
    if (synthVisOn) {
      var washR = Math.max(W, H) * 0.72;
      var washAlpha = 0.08 + Math.sin(bgT * 0.012) * 0.03;
      var wg = bgCtx.createRadialGradient(cx, cy, 0, cx, cy, washR);
      wg.addColorStop(0,   'rgba(255,140,50,' + washAlpha.toFixed(3) + ')');
      wg.addColorStop(0.5, 'rgba(100,180,255,' + (washAlpha * 0.4).toFixed(3) + ')');
      wg.addColorStop(1,   'rgba(0,0,0,0)');
      bgCtx.fillStyle = wg;
      bgCtx.fillRect(0, 0, W, H);

      // Secondary drifting wash
      var θ2 = bgT * 0.0008;
      var ox = cx + Math.cos(θ2) * W * 0.18;
      var oy = cy + Math.sin(θ2) * H * 0.14;
      var wg2 = bgCtx.createRadialGradient(ox, oy, 0, ox, oy, Math.max(W, H) * 0.9);
      wg2.addColorStop(0,   'rgba(210,170,255,0.06)');
      wg2.addColorStop(0.5, 'rgba(100,200,255,0.02)');
      wg2.addColorStop(1,   'rgba(0,0,0,0)');
      bgCtx.fillStyle = wg2;
      bgCtx.fillRect(0, 0, W, H);
    }

    // ── Celestial star globe (night only) ───────────────────────────
    if (!vzDay) {
      var θ    = (t / 3600000) * Math.PI * 2;
      var wobX = Math.sin(t * 0.0000262) * 0.055;
      var wobZ = Math.cos(t * 0.0000151) * 0.038;
      var cθ = Math.cos(θ), sθ = Math.sin(θ);
      var cX = Math.cos(wobX), sX = Math.sin(wobX);
      var cZ = Math.cos(wobZ), sZ = Math.sin(wobZ);
      var globeR = Math.hypot(cx, cy) * 1.62;
      var starBoost = (synthVisOn ? 1.5 : 1.0) * (1 + audioEnergy * 1.5);

      STAR_3D.forEach(function(s) {
        var x1 = s.x * cθ - s.y * sθ;
        var y1 = s.x * sθ + s.y * cθ;
        var z1 = s.z;
        var x2 = x1;
        var y2 = y1 * cX - z1 * sX;
        var z2 = y1 * sX + z1 * cX;
        var x3 = x2 * cZ - y2 * sZ;
        var y3 = x2 * sZ + y2 * cZ;
        var z3 = z2;

        if (y3 < 0) return;
        var sx = cx + x3 * globeR;
        var sy = cy - z3 * globeR;
        if (sx < -4 || sx > W + 4 || sy < -4 || sy > H + 4) return;

        var limbFade = Math.pow(y3, 0.20);
        var twink = Math.sin(t * 0.0008 + s.phase) * 0.18;
        var alpha = Math.max(0, Math.min(1, (s.baseAlpha + twink) * limbFade * starBoost));
        if (alpha < 0.01) return;

        if (s.glow) {
          bgCtx.beginPath();
          bgCtx.arc(sx, sy, s.r * 2.6, 0, Math.PI * 2);
          bgCtx.fillStyle = 'rgba(220,230,255,' + (alpha * 0.15).toFixed(3) + ')';
          bgCtx.fill();
        }
        bgCtx.beginPath();
        bgCtx.arc(sx, sy, s.r, 0, Math.PI * 2);
        bgCtx.fillStyle = 'rgba(255,255,255,' + alpha.toFixed(2) + ')';
        bgCtx.fill();
      });
    }

    // ── Ripples ──────────────────────────────────────────────────────
    for (var i = ripples.length - 1; i >= 0; i--) {
      var rip = ripples[i];
      var age = (t - rip.born) / (9000 / rip.speed);
      if (age >= 1) { ripples.splice(i, 1); continue; }

      var r2 = age * rip.maxR;
      var alpha2 = (1 - age) * 0.55;
      var rot = rip.rotation + rip.rotSpeed * age * Math.PI;

      bgCtx.save();
      if (rip.shape === 'halo')  drawHalo(bgCtx, cx, cy, r2, alpha2, rip.glow, age);
      else                       drawFlower(bgCtx, cx, cy, r2, rip.petals, rot, alpha2, rip.glow, age);
      bgCtx.restore();
    }

    // ── Moon / Sun ───────────────────────────────────────────────────
    if (vzDay) {
      drawSun(bgCtx, cx, cy, W, H, t);
    } else if (GEO.lat !== null) {
      drawMoon(bgCtx, cx, cy, W, H, t);
    }

    requestAnimationFrame(drawBg);
  }

  if (bgCanvas) {
    resizeBg();
    window.addEventListener('resize', resizeBg);
    requestAnimationFrame(drawBg);
  }

  // ── 7. Astronomy: location, sun & moon ─────────────────────────────────────
  var GEO = { lat: null, lon: null };

  // Silent IP-based location only — no browser permission prompt
  fetchIPGeo();

  function fetchIPGeo() {
    fetch('https://ipapi.co/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) { GEO.lat = parseFloat(d.latitude); GEO.lon = parseFloat(d.longitude); })
      .catch(function () { GEO.lat = 37.7; GEO.lon = -122.4; }); // SF fallback
  }

  function sunAltitudeDeg(lat, lon) {
    var d   = new Date();
    var doy = Math.floor((d - new Date(d.getFullYear(), 0, 0)) / 86400000);
    var decl = -23.45 * Math.cos(2 * Math.PI / 365 * (doy + 10));
    var utcH = d.getUTCHours() + d.getUTCMinutes() / 60;
    var solarH = utcH + lon / 15;
    var hourAngle = (solarH - 12) * 15; // degrees
    var sinAlt = Math.sin(lat * Math.PI / 180) * Math.sin(decl * Math.PI / 180)
               + Math.cos(lat * Math.PI / 180) * Math.cos(decl * Math.PI / 180)
               * Math.cos(hourAngle * Math.PI / 180);
    return Math.asin(Math.max(-1, Math.min(1, sinAlt))) * 180 / Math.PI;
  }

  function moonPhase() {
    var jd = Date.now() / 86400000 + 2440587.5;
    var p  = ((jd - 2451550.1) / 29.53058867) % 1;
    return p < 0 ? p + 1 : p;
  }

  function moonAltitudeDeg(lat, lon) {
    var phase = moonPhase();
    // Moon rises ~50 min (≈0.83°) later each day relative to sun; offset by phase
    var offsetHours = phase * 24.84;
    var d2 = new Date(Date.now() - offsetHours * 3600000);
    var doy = Math.floor((d2 - new Date(d2.getFullYear(), 0, 0)) / 86400000);
    var decl = -23.45 * Math.cos(2 * Math.PI / 365 * (doy + 10));
    var utcH = d2.getUTCHours() + d2.getUTCMinutes() / 60;
    var solarH = utcH + lon / 15;
    var hourAngle = (solarH - 12) * 15;
    var sinAlt = Math.sin(lat * Math.PI / 180) * Math.sin(decl * Math.PI / 180)
               + Math.cos(lat * Math.PI / 180) * Math.cos(decl * Math.PI / 180)
               * Math.cos(hourAngle * Math.PI / 180);
    return Math.asin(Math.max(-1, Math.min(1, sinAlt))) * 180 / Math.PI;
  }

  function drawMoon(ctx, cx, cy, W, H, t) {
    var lat = GEO.lat, lon = GEO.lon;
    var mAlt = moonAltitudeDeg(lat, lon);
    if (mAlt <= 0) return; // below horizon

    var phase    = moonPhase();
    var moonR    = Math.min(W, H) * 0.055;  // fairly large
    // Position: upper area, left/right based on time
    var mAngle   = (mAlt / 90) * Math.PI / 2;
    var mX       = cx - Math.cos(mAngle) * (W * 0.35);
    var mY       = cy - (mAlt / 90) * H * 0.42 - moonR;
    mX = Math.max(moonR + 20, Math.min(W - moonR - 20, mX));
    mY = Math.max(moonR + 20, Math.min(H * 0.55, mY));

    // Soft glow halo
    var glow = ctx.createRadialGradient(mX, mY, moonR * 0.5, mX, mY, moonR * 2.5);
    glow.addColorStop(0,   'rgba(220, 225, 255, 0.14)');
    glow.addColorStop(0.5, 'rgba(180, 190, 255, 0.05)');
    glow.addColorStop(1,   'rgba(120, 130, 255, 0)');
    ctx.fillStyle = glow;
    ctx.beginPath();
    ctx.arc(mX, mY, moonR * 2.5, 0, Math.PI * 2);
    ctx.fill();

    // Moon disc (bright side)
    ctx.save();
    ctx.beginPath();
    ctx.arc(mX, mY, moonR, 0, Math.PI * 2);
    ctx.fillStyle = 'rgba(235, 238, 255, 0.90)';
    ctx.fill();

    // Phase shadow (dark side)
    // phase 0=new, 0.25=first quarter, 0.5=full, 0.75=last quarter
    var illum = phase <= 0.5 ? phase * 2 : (1 - phase) * 2; // 0=new, 1=full
    ctx.beginPath();
    ctx.arc(mX, mY, moonR, Math.PI / 2, -Math.PI / 2, phase < 0.5);
    // Shadow ellipse for crescent
    var ex = (1 - illum * 2) * moonR; // -moonR (new) → 0 (quarter) → +moonR (full→new)
    ctx.ellipse(mX, mY, Math.abs(ex) || 0.5, moonR, 0,
      phase < 0.5 ? -Math.PI / 2 : Math.PI / 2,
      phase < 0.5 ? Math.PI / 2 : -Math.PI / 2,
      phase >= 0.5);
    ctx.closePath();
    ctx.fillStyle = 'rgba(4, 4, 18, 0.93)';
    ctx.fill();

    // Subtle surface texture
    ctx.globalAlpha = 0.12;
    ctx.fillStyle = 'rgba(150, 160, 200, 0.4)';
    [[0.3, 0.25, 0.18], [-0.2, -0.15, 0.12], [0.1, 0.4, 0.1]].forEach(function(c) {
      ctx.beginPath();
      ctx.arc(mX + c[0] * moonR, mY + c[1] * moonR, c[2] * moonR, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.globalAlpha = 1;
    ctx.restore();
  }

  function drawSun(ctx, cx, cy, W, H, t) {
    // Sun: upper-right area, slow arc across sky
    var sunX = W * 0.72 + Math.sin(t * 0.00004) * W * 0.05;
    var sunY = H * 0.18 + Math.cos(t * 0.000028) * H * 0.06;
    var sunR = Math.min(W, H) * 0.048;
    var pulse = 0.9 + Math.sin(t * 0.00035) * 0.1;

    // Outer warmth halo
    var halo = ctx.createRadialGradient(sunX, sunY, sunR * 0.4, sunX, sunY, sunR * 5.5);
    halo.addColorStop(0,   'rgba(255, 220, 100, 0.22)');
    halo.addColorStop(0.3, 'rgba(255, 180, 40,  0.09)');
    halo.addColorStop(1,   'rgba(255, 140, 20,  0)');
    ctx.fillStyle = halo;
    ctx.beginPath(); ctx.arc(sunX, sunY, sunR * 5.5, 0, Math.PI * 2); ctx.fill();

    // Sun disc glow
    var disc = ctx.createRadialGradient(sunX, sunY, 0, sunX, sunY, sunR * pulse);
    disc.addColorStop(0,   'rgba(255, 255, 220, 1)');
    disc.addColorStop(0.5, 'rgba(255, 230, 100, 0.95)');
    disc.addColorStop(1,   'rgba(255, 180, 40,  0.85)');
    ctx.fillStyle = disc;
    ctx.beginPath(); ctx.arc(sunX, sunY, sunR * pulse, 0, Math.PI * 2); ctx.fill();

    // Short sun rays
    ctx.save();
    ctx.strokeStyle = 'rgba(255, 220, 100, 0.30)';
    ctx.lineWidth = 1.5;
    ctx.lineCap = 'round';
    for (var ri = 0; ri < 8; ri++) {
      var rAngle = (ri / 8) * Math.PI * 2 + t * 0.0001;
      var r1 = sunR * 1.4, r2 = sunR * 2.2;
      ctx.beginPath();
      ctx.moveTo(sunX + Math.cos(rAngle) * r1, sunY + Math.sin(rAngle) * r1);
      ctx.lineTo(sunX + Math.cos(rAngle) * r2, sunY + Math.sin(rAngle) * r2);
      ctx.stroke();
    }
    ctx.restore();
  }

  // Day/night tint — applied as bg canvas overlay using sun altitude
  // (integrated into blob lBoost and wash logic — sunAlt accessed in drawBg)
  var _lastSunUpdate = 0;
  var _sunAlt = null;
  function getSunAlt() {
    var now = Date.now();
    if (GEO.lat === null || now - _lastSunUpdate < 60000) return _sunAlt;
    _sunAlt = sunAltitudeDeg(GEO.lat, GEO.lon);
    _lastSunUpdate = now;
    return _sunAlt;
  }

  // ── 8. Mouse wind on smoke (Task 4) ────────────────────────────────────────
  var _smokeMouseX = 0;
  var _smokeLastX  = 0;
  var vzSection2   = document.getElementById('vibe-zone');
  if (vzSection2) {
    vzSection2.addEventListener('mousemove', function (e) {
      var rect = vzSection2.getBoundingClientRect();
      var mx = e.clientX - rect.left;
      var dx = mx - _smokeLastX;
      _smokeLastX = mx;
      if (window._smokeInst && Math.abs(dx) > 0.5) {
        window._smokeInst.applyWind(mx, dx);
      }
    });
  }

  // ── 2. Proximity hover magnification ────────────────────────────────────────
  var vzObjs = document.querySelectorAll('.vz-obj');
  // Proximity hover scaling disabled per user request — was confusing
  // (kept as no-op so the vsSection mouseleave reset below still works cleanly)

  var vzSection = document.getElementById('vibe-zone');
  if (vzSection) {
    vzSection.addEventListener('mouseleave', function () {
      vzObjs.forEach(function (obj) { obj.style.transform = 'scale(1)'; });
    });
  }

  // ── 2b. Start fullscreen by default (fill viewport below header, no scroll needed) ──
  function syncViewportFill() {
    if (!vzSection) return;
    var header = document.querySelector('header') || document.querySelector('.shopify-section-header');
    var headerH = header ? header.getBoundingClientRect().height : 0;
    var fillPx = Math.max(320, window.innerHeight - headerH);
    vzSection.style.setProperty('--vz-min-height', fillPx + 'px');
  }
  syncViewportFill();
  window.addEventListener('resize', syncViewportFill);
  window.addEventListener('orientationchange', syncViewportFill);

  // Optional true browser Fullscreen API — requires a user gesture, so it's
  // offered as a button, and also triggered by the buggone click itself
  // (that click is a real user gesture too) rather than on page load.
  var fsSupported = !!(document.documentElement.requestFullscreen ||
    document.documentElement.webkitRequestFullscreen);

  function isRealFullscreen() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement);
  }
  function enterRealFullscreen() {
    if (!fsSupported || isRealFullscreen()) return;
    var el = document.documentElement;
    if (el.requestFullscreen) el.requestFullscreen();
    else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
  }
  function exitRealFullscreen() {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
  }

  var fsToggle = document.getElementById('vz-fullscreen-toggle');
  if (fsToggle) {
    if (!fsSupported) {
      fsToggle.setAttribute('hidden', '');
    } else {
      fsToggle.addEventListener('click', function () {
        if (isRealFullscreen()) exitRealFullscreen();
        else enterRealFullscreen();
      });
      var syncFsState = function () {
        var isFs = isRealFullscreen();
        fsToggle.classList.toggle('is-fullscreen', isFs);
        fsToggle.setAttribute('aria-pressed', isFs ? 'true' : 'false');
        fsToggle.title = isFs ? 'Exit fullscreen' : 'Enter fullscreen';
      };
      document.addEventListener('fullscreenchange', syncFsState);
      document.addEventListener('webkitfullscreenchange', syncFsState);
    }
  }

  // ── 3. Module activation ────────────────────────────────────────────────────
  var active = { boombox: false, synth: false, buggone: false };

  // audioEnergy stays 0 — was previously driven by mic capture, removed because
  // requesting mic permission when activating boombox was confusing/unwanted
  var audioEnergy = 0;
  var micAnalyser = null;
  var micFData    = null;

  function toggle(name) {
    active[name] = !active[name];
    var el = document.getElementById('vz-' + name);
    if (el) el.classList.toggle('vz-obj--active', active[name]);

    if      (name === 'boombox') active.boombox ? startBoombox() : stopBoombox();
    else if (name === 'synth')   active.synth   ? startSynth()   : stopSynth();
    else if (name === 'buggone') active.buggone ? startBugs()    : stopBugs();

  }

  vzObjs.forEach(function (obj) {
    obj.addEventListener('click', function (e) {
      // Don't toggle if click originated inside a floating panel child
      if (e.target.closest('.vz-boombox-panel')) return;
      var m = obj.dataset.module;
      if (m) toggle(m);
    });
  });

  // ── 4. Boombox — YouTube IFrame ─────────────────────────────────────────────
  // Playlist: Casa Aura client playlist (swapped from Moomaw placeholder 2026-08-24)
  var YT_PLAYLIST = 'PLAz16ij1x-yk';
  var ytPlayer = null;
  var ytReady  = false;

  window.onYouTubeIframeAPIReady = function () {
    ytReady = true;
    if (active.boombox) buildYTPlayer();
  };

  function startBoombox() {
    var panel = document.getElementById('vz-boombox-panel');
    if (panel) {
      panel.removeAttribute('hidden');
      // Stop any click inside the panel from bubbling to the vz-obj toggle
      if (!panel._clickGuard) {
        panel.addEventListener('click', function(e) { e.stopPropagation(); });
        panel._clickGuard = true;
      }
    }

    if (!window.YT) {
      var s = document.createElement('script');
      s.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(s);
    } else if (ytReady) {
      buildYTPlayer();
    }
  }

  function buildYTPlayer() {
    if (ytPlayer) { try { ytPlayer.playVideo(); } catch (e) {} return; }
    ytPlayer = new YT.Player('vz-yt-player', {
      height: '180',
      width: '300',
      playerVars: {
        listType:       'playlist',
        list:           YT_PLAYLIST,
        autoplay:       1,
        controls:       1,
        modestbranding: 1,
        rel:            0,
      },
    });
  }

  function stopBoombox() {
    var panel = document.getElementById('vz-boombox-panel');
    if (panel) panel.setAttribute('hidden', '');
    if (ytPlayer) { try { ytPlayer.pauseVideo(); } catch (e) {} }
  }

  // ── 5. Synth — Vibe audio engine (fire + water + chime) ────────────────────
  // Ported from /Sites/vibe/src/audio/ (tones.js, noise.js)
  var synthCtx    = null;
  var synthMaster = null;
  var synthNodes  = [];   // continuous sources
  var synthTimers = [];   // interval ids

  // Build a looping pink-noise buffer
  function makePinkBuf(ctx, sec) {
    var sr  = ctx.sampleRate;
    var len = Math.floor(sr * sec);
    var buf = ctx.createBuffer(2, len, sr);
    for (var ch = 0; ch < 2; ch++) {
      var d = buf.getChannelData(ch);
      var b0=0,b1=0,b2=0,b3=0,b4=0,b5=0,b6=0;
      for (var i = 0; i < len; i++) {
        var w = Math.random() * 2 - 1;
        b0=0.99886*b0+w*0.0555179; b1=0.99332*b1+w*0.0750759;
        b2=0.96900*b2+w*0.1538520; b3=0.86650*b3+w*0.3104856;
        b4=0.55000*b4+w*0.5329522; b5=-0.7616*b5-w*0.0168980;
        d[i]=(b0+b1+b2+b3+b4+b5+b6+w*0.5362)*0.11; b6=w*0.115926;
      }
    }
    return buf;
  }

  // Candle-fire crackle — soft, meditative
  function makeCandle(ctx) {
    var len = Math.floor(ctx.sampleRate * 6);
    var buf = ctx.createBuffer(2, len, ctx.sampleRate);
    for (var ch = 0; ch < 2; ch++) {
      var d = buf.getChannelData(ch);
      var b0=0, b1=0;
      for (var i = 0; i < len; i++) {
        var w = Math.random() * 2 - 1;
        b0=0.99886*b0+w*0.0555179; b1=0.99332*b1+w*0.0750759;
        d[i]=(b0+b1)*0.5;
      }
    }
    var src = ctx.createBufferSource();
    src.buffer = buf; src.loop = true;
    var lpf = ctx.createBiquadFilter();
    lpf.type = 'lowpass'; lpf.frequency.value = 400; lpf.Q.value = 0.8;
    var lfo = ctx.createOscillator();
    var lfoG = ctx.createGain();
    lfo.type = 'sine'; lfo.frequency.value = 0.55; lfoG.gain.value = 0.08;
    lfo.connect(lfoG);
    var gain = ctx.createGain(); gain.gain.value = 0.18;
    lfoG.connect(gain.gain);
    src.connect(lpf); lpf.connect(gain);
    src.start(); lfo.start();
    return { gain: gain, stop: function() { try { src.stop(); lfo.stop(); } catch(e){} } };
  }

  // Gentle rain — outdoor, calming
  function makeRain(ctx) {
    var src = ctx.createBufferSource();
    src.buffer = makePinkBuf(ctx, 6); src.loop = true;
    var hpf = ctx.createBiquadFilter();
    hpf.type = 'highpass'; hpf.frequency.value = 600;
    var bpf = ctx.createBiquadFilter();
    bpf.type = 'bandpass'; bpf.frequency.value = 2600; bpf.Q.value = 0.5;
    var lfo = ctx.createOscillator();
    var lfoG = ctx.createGain();
    lfo.frequency.value = 0.4; lfoG.gain.value = 600;
    lfo.connect(lfoG); lfoG.connect(bpf.frequency);
    var gain = ctx.createGain(); gain.gain.value = 0.28;
    src.connect(hpf); hpf.connect(bpf); bpf.connect(gain);
    src.start(); lfo.start();
    return { gain: gain, stop: function() { try { src.stop(); lfo.stop(); } catch(e){} } };
  }

  // Bell tone (FM synthesis — from vibe tones.js)
  function ringBell(ctx, out, freq, vol) {
    var now = ctx.currentTime;
    var carrier = ctx.createOscillator();
    var mod     = ctx.createOscillator();
    var modG    = ctx.createGain();
    var env     = ctx.createGain();
    carrier.type = 'sine'; carrier.frequency.value = freq;
    mod.type     = 'sine'; mod.frequency.value     = freq * 2.756;
    modG.gain.value = freq * 3;
    env.gain.setValueAtTime(0.001, now);
    env.gain.linearRampToValueAtTime(vol, now + 0.008);
    env.gain.exponentialRampToValueAtTime(0.001, now + 4.2);
    mod.connect(modG); modG.connect(carrier.frequency);
    carrier.connect(env); env.connect(out);
    mod.start(now); mod.stop(now + 4.8);
    carrier.start(now); carrier.stop(now + 4.8);
  }

  // Chime — random pentatonic frequency
  function ringChime(ctx, out, vol) {
    var scale = [523, 587, 659, 698, 784, 880, 988, 1047];
    var freq  = scale[Math.floor(Math.random() * scale.length)];
    ringBell(ctx, out, freq * (0.98 + Math.random() * 0.04), vol * 0.7);
  }

  // Shared short reverb
  // Gong — deep FM bass hit
  function triggerGong(ctx, out, vol) {
    var now = ctx.currentTime;
    var freq = 55 + Math.random() * 35;
    var carrier = ctx.createOscillator();
    var m1 = ctx.createOscillator(); var m2 = ctx.createOscillator();
    var mg1 = ctx.createGain(); var mg2 = ctx.createGain();
    var env = ctx.createGain();
    carrier.type = 'sine'; carrier.frequency.value = freq;
    m1.type = 'sine'; m1.frequency.value = freq * 3.5;
    m2.type = 'sine'; m2.frequency.value = freq * 7.1;
    mg1.gain.value = freq * 10; mg2.gain.value = freq * 4;
    env.gain.setValueAtTime(0.001, now);
    env.gain.linearRampToValueAtTime(vol, now + 0.04);
    env.gain.exponentialRampToValueAtTime(0.001, now + 9.0);
    m1.connect(mg1); mg1.connect(carrier.frequency);
    m2.connect(mg2); mg2.connect(carrier.frequency);
    carrier.connect(env); env.connect(out);
    m1.start(now); m1.stop(now + 9.5);
    m2.start(now); m2.stop(now + 9.5);
    carrier.start(now); carrier.stop(now + 9.5);
  }

  // Birds — short chirpy oscillators
  function triggerBirds(ctx, out, vol) {
    var count = 2 + Math.floor(Math.random() * 4);
    for (var n = 0; n < count; n++) {
      (function(offset) {
        var f0 = 1800 + Math.random() * 3200;
        var f1 = f0 * (0.6 + Math.random() * 0.8);
        var dur = 0.04 + Math.random() * 0.18;
        var now = ctx.currentTime;
        var osc = ctx.createOscillator(); var env = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.setValueAtTime(f0, now + offset);
        osc.frequency.exponentialRampToValueAtTime(f1, now + offset + dur);
        env.gain.setValueAtTime(0.001, now + offset);
        env.gain.linearRampToValueAtTime(vol * 0.35, now + offset + 0.01);
        env.gain.exponentialRampToValueAtTime(0.001, now + offset + dur);
        osc.connect(env); env.connect(out);
        osc.start(now + offset); osc.stop(now + offset + dur + 0.05);
      })(n * (0.04 + Math.random() * 0.12));
    }
  }

  // Water — pink noise filtered as stream/rain
  function makeWater(ctx) {
    var src = ctx.createBufferSource();
    src.buffer = makePinkBuf(ctx, 6); src.loop = true;
    var bpf = ctx.createBiquadFilter(); bpf.type = 'bandpass'; bpf.frequency.value = 1200; bpf.Q.value = 0.8;
    var lfo = ctx.createOscillator(); var lfoG = ctx.createGain();
    lfo.frequency.value = 0.7; lfoG.gain.value = 400;
    lfo.connect(lfoG); lfoG.connect(bpf.frequency);
    var gain = ctx.createGain(); gain.gain.value = 0.55;
    src.connect(bpf); bpf.connect(gain);
    src.start(); lfo.start();
    return { gain: gain, stop: function() { try { src.stop(); lfo.stop(); } catch(e){} } };
  }

  // Wind — pink noise with bandpass LFO
  function makeWind(ctx) {
    var len = Math.floor(ctx.sampleRate * 8);
    var buf = ctx.createBuffer(2, len, ctx.sampleRate);
    for (var ch = 0; ch < 2; ch++) {
      var d = buf.getChannelData(ch), b0=0, b1=0, b2=0, b3=0, b4=0;
      for (var i = 0; i < len; i++) {
        var w = Math.random() * 2 - 1;
        b0=0.99886*b0+w*0.0555179; b1=0.99332*b1+w*0.0750759;
        b2=0.96900*b2+w*0.1538520; b3=0.86650*b3+w*0.3104856;
        b4=0.55000*b4+w*0.5329522;
        d[i] = (b0+b1+b2+b3+b4) * 0.18;
      }
    }
    var src = ctx.createBufferSource(); src.buffer = buf; src.loop = true;
    var bpf = ctx.createBiquadFilter(); bpf.type = 'bandpass'; bpf.frequency.value = 380; bpf.Q.value = 0.7;
    var lfo = ctx.createOscillator(); var lfoG = ctx.createGain();
    lfo.type = 'sine'; lfo.frequency.value = 0.04; lfoG.gain.value = 180;
    lfo.connect(lfoG); lfoG.connect(bpf.frequency);
    var gain = ctx.createGain(); gain.gain.value = 0.45;
    src.connect(bpf); bpf.connect(gain);
    src.start(); lfo.start();
    return { gain: gain, stop: function() { try { src.stop(); lfo.stop(); } catch(e){} } };
  }

  // Earth — sub bass rumble + LFO
  function makeEarth(ctx) {
    var src = ctx.createBufferSource();
    src.buffer = makePinkBuf(ctx, 8); src.loop = true;
    var lpf = ctx.createBiquadFilter(); lpf.type = 'lowpass'; lpf.frequency.value = 90; lpf.Q.value = 1.5;
    var sub = ctx.createOscillator(); var subG = ctx.createGain();
    sub.type = 'sine'; sub.frequency.value = 38; subG.gain.value = 0.4;
    var aLfo = ctx.createOscillator(); var aLfoG = ctx.createGain();
    aLfo.frequency.value = 0.04; aLfoG.gain.value = 0.2; aLfo.connect(aLfoG);
    var gain = ctx.createGain(); gain.gain.value = 0.6;
    aLfoG.connect(gain.gain);
    src.connect(lpf); lpf.connect(gain);
    sub.connect(subG); subG.connect(gain);
    src.start(); sub.start(); aLfo.start();
    return { gain: gain, stop: function() { try { src.stop(); sub.stop(); aLfo.stop(); } catch(e){} } };
  }

  function makeReverb(ctx) {
    var conv = ctx.createConvolver();
    var len  = Math.floor(ctx.sampleRate * 2.5);
    var buf  = ctx.createBuffer(2, len, ctx.sampleRate);
    for (var ch = 0; ch < 2; ch++) {
      var d = buf.getChannelData(ch);
      for (var i = 0; i < len; i++)
        d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2);
    }
    conv.buffer = buf;
    return conv;
  }

  // Vibe controls state — which sounds are enabled + their volumes (0–1)
  // ── Sound state (matches vibe app structure) ──────────────────────────────
  var ELEMENTAL_TYPES = {
    fire:  ['candle',  'campfire', 'bonfire'],
    wind:  ['breeze',  'gale',     'squall'],
    water: ['stream',  'rain',     'ocean'],
    earth: ['loam',    'stone',    'crystal'],
  };
  var NOISE_FILTER = { white: 'allpass', pink: 'lowpass', blue: 'highpass' };

  // Noise: { on, vol, freq, node }
  var synthNoise = {
    white: { on: false, vol: 0.5, freq: 2000, node: null },
    pink:  { on: false, vol: 0.5, freq: 900,  node: null },
    blue:  { on: false, vol: 0.5, freq: 3500, node: null },
  };
  // Tones: periodic triggers
  var synthTones = {
    bell:  { on: true,  vol: 0.5, rate: 25,  node: null },
    chime: { on: true,  vol: 0.5, rate: 10,  node: null },
    gong:  { on: false, vol: 0.5, rate: 55,  node: null },
    birds: { on: false, vol: 0.5, rate: 14,  node: null },
  };
  // Elemental: continuous
  var synthElem = {
    fire:  { on: true,  vol: 0.6, type: 0, node: null },
    wind:  { on: false, vol: 0.5, type: 0, node: null },
    water: { on: false, vol: 0.5, type: 0, node: null },
    earth: { on: false, vol: 0.5, type: 0, node: null },
  };

  var synthReverb = null;

  // Noise audio: looping BufferSource → filter → gain
  function makeWhiteNoise(ctx, freq) {
    var len = Math.floor(ctx.sampleRate * 6);
    var buf = ctx.createBuffer(2, len, ctx.sampleRate);
    for (var ch = 0; ch < 2; ch++) { var d = buf.getChannelData(ch); for (var i=0; i<len; i++) d[i]=Math.random()*2-1; }
    var src = ctx.createBufferSource(); src.buffer = buf; src.loop = true;
    var filt = ctx.createBiquadFilter(); filt.type = 'allpass'; filt.frequency.value = freq; filt.Q.value = 0.7;
    var gain = ctx.createGain();
    src.connect(filt); filt.connect(gain); src.start();
    return { gain: gain, filter: filt, stop: function() { try { src.stop(); } catch(e){} } };
  }
  function makePinkNoiseNode(ctx, freq) {
    var src = ctx.createBufferSource();
    src.buffer = makePinkBuf(ctx, 6); src.loop = true;
    var filt = ctx.createBiquadFilter(); filt.type = 'lowpass'; filt.frequency.value = freq; filt.Q.value = 0.7;
    var gain = ctx.createGain();
    src.connect(filt); filt.connect(gain); src.start();
    return { gain: gain, filter: filt, stop: function() { try { src.stop(); } catch(e){} } };
  }
  function makeBlueNoise(ctx, freq) {
    var len = Math.floor(ctx.sampleRate * 6);
    var buf = ctx.createBuffer(2, len, ctx.sampleRate);
    for (var ch = 0; ch < 2; ch++) { var d = buf.getChannelData(ch); var prev=0; for (var i=0; i<len; i++) { var w=Math.random()*2-1; d[i]=(w-prev)*0.5; prev=w; } }
    var src = ctx.createBufferSource(); src.buffer = buf; src.loop = true;
    var filt = ctx.createBiquadFilter(); filt.type = 'highpass'; filt.frequency.value = freq; filt.Q.value = 0.7;
    var gain = ctx.createGain();
    src.connect(filt); filt.connect(gain); src.start();
    return { gain: gain, filter: filt, stop: function() { try { src.stop(); } catch(e){} } };
  }

  // Boombox audio URL → vibe filter chain (ported from vibe engine.js setAudioInput)
  var inputAudio = null; var inputNodes = [];

  function playAudioInput(url) {
    stopAudioInput();
    if (!synthCtx) return;
    var audio = new Audio();
    audio.crossOrigin = 'anonymous';
    audio.src = url; audio.loop = true;
    var src = synthCtx.createMediaElementSource(audio);
    var out = synthCtx.createGain(); out.gain.value = 0.75;
    out.connect(synthMaster);
    // Route through each active noise filter
    var filters = [];
    Object.keys(synthNoise).forEach(function(id) {
      var n = synthNoise[id];
      if (n.on) {
        var f = synthCtx.createBiquadFilter();
        f.type = NOISE_FILTER[id];
        f.frequency.value = n.freq; f.Q.value = 1.5;
        src.connect(f); f.connect(out);
        filters.push(f);
      }
    });
    if (filters.length === 0) {
      src.connect(out);
    } else {
      out.gain.value = 0.75 / filters.length;
    }
    inputAudio = audio;
    inputNodes = [src, out].concat(filters);
    return audio.play();
  }

  function stopAudioInput() {
    if (inputAudio) { inputAudio.pause(); inputAudio.src = ''; inputAudio = null; }
    inputNodes.forEach(function(n) { try { n.disconnect(); } catch(e){} });
    inputNodes = [];
  }

  // ── Trigram helpers ────────────────────────────────────────────────────────
  function triMorphLines(id, val) {
    var tm = ELEM_TRIGRAMS[id];
    if (!tm) return [1,1,1];
    var t = 0.5 - 0.5 * Math.cos((val / 2) * Math.PI);
    var b = TRIGRAMS[tm.base], p = TRIGRAMS[tm.pair];
    return b.map(function(bv, i) { return bv + (p[i] - bv) * t; });
  }
  function triName(id, val) {
    var tm = ELEM_TRIGRAMS[id];
    if (!tm) return '';
    var t = 0.5 - 0.5 * Math.cos((val / 2) * Math.PI);
    return (t < 0.5 ? tm.base : tm.pair).toLowerCase();
  }
  function drawTrigramSVG(svgEl, lines, color) {
    var ns = 'http://www.w3.org/2000/svg';
    while (svgEl.firstChild) svgEl.removeChild(svgEl.firstChild);
    var W = 22, pad = 3, lineH = 3, spacing = 3, innerW = W - pad * 2;
    var gapW = Math.round(innerW * 0.4); // yin gap width
    // outline color: slightly lighter version of the slot color
    var outlineColor = 'rgba(255,255,255,0.38)';

    for (var i = 0; i < 3; i++) {
      var t = Math.max(0, Math.min(1, lines[i]));
      var y = pad + i * (lineH + spacing);
      var barW = Math.round(innerW * (0.4 + 0.1 * t));

      // Fill: morphing bar pair
      var r1 = document.createElementNS(ns, 'rect');
      r1.setAttribute('x', pad); r1.setAttribute('y', y);
      r1.setAttribute('width', barW); r1.setAttribute('height', lineH);
      r1.setAttribute('fill', color); r1.setAttribute('rx', 1);
      svgEl.appendChild(r1);
      var r2 = document.createElementNS(ns, 'rect');
      r2.setAttribute('x', pad + (innerW - barW)); r2.setAttribute('y', y);
      r2.setAttribute('width', barW); r2.setAttribute('height', lineH);
      r2.setAttribute('fill', color); r2.setAttribute('rx', 1);
      svgEl.appendChild(r2);

      // Outline: crisp stroke of nearest discrete trigram line
      var yang = Math.round(t) === 1; // solid or broken
      if (yang) {
        // Yang (solid) — full-width stroke outline
        var ol = document.createElementNS(ns, 'rect');
        ol.setAttribute('x', pad); ol.setAttribute('y', y);
        ol.setAttribute('width', innerW); ol.setAttribute('height', lineH);
        ol.setAttribute('fill', 'none');
        ol.setAttribute('stroke', outlineColor);
        ol.setAttribute('stroke-width', '0.9');
        ol.setAttribute('rx', 1);
        svgEl.appendChild(ol);
      } else {
        // Yin (broken) — two short stroke rects with gap
        var olA = document.createElementNS(ns, 'rect');
        olA.setAttribute('x', pad); olA.setAttribute('y', y);
        olA.setAttribute('width', gapW); olA.setAttribute('height', lineH);
        olA.setAttribute('fill', 'none');
        olA.setAttribute('stroke', outlineColor);
        olA.setAttribute('stroke-width', '0.9');
        olA.setAttribute('rx', 1);
        svgEl.appendChild(olA);
        var olB = document.createElementNS(ns, 'rect');
        olB.setAttribute('x', pad + innerW - gapW); olB.setAttribute('y', y);
        olB.setAttribute('width', gapW); olB.setAttribute('height', lineH);
        olB.setAttribute('fill', 'none');
        olB.setAttribute('stroke', outlineColor);
        olB.setAttribute('stroke-width', '0.9');
        olB.setAttribute('rx', 1);
        svgEl.appendChild(olB);
      }
    }
  }

  // ── DualKnob (vanilla JS port of vibe app DualKnob) ───────────────────────
  var MIN_ANGLE = -135, ANGLE_RANGE = 270, INNER_RATIO = 0.55;
  var VK_SIZE = 72;

  function buildKnob(container, color, initVol, initParam, pMin, pMax, onVol, onParam, paramLabel) {
    var strokeW = VK_SIZE * 0.115;
    var ringR   = (VK_SIZE / 2) - strokeW / 2 - 1;
    var circ    = 2 * Math.PI * ringR;
    var trackLen = (ANGLE_RANGE / 360) * circ;

    var volAngle   = initVol * ANGLE_RANGE;
    var fillLen    = (volAngle / 360) * circ;
    var pRatio     = Math.max(0, Math.min(1, (initParam - pMin) / (pMax - pMin)));
    var paramDeg   = MIN_ANGLE + pRatio * ANGLE_RANGE;

    var ns = 'http://www.w3.org/2000/svg';
    var body = document.createElement('div');
    body.className = 'vk__body';
    body.style.setProperty('--vk-size', VK_SIZE + 'px');
    body.style.touchAction = 'none';

    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('class', 'vk__svg');
    svg.setAttribute('viewBox', '0 0 ' + VK_SIZE + ' ' + VK_SIZE);
    svg.setAttribute('width', '100%'); svg.setAttribute('height', '100%');

    function mkCircle(cls, r, sw, dash, dashOff) {
      var c = document.createElementNS(ns, 'circle');
      c.setAttribute('class', cls);
      c.setAttribute('cx', VK_SIZE/2); c.setAttribute('cy', VK_SIZE/2); c.setAttribute('r', r);
      c.setAttribute('fill', 'none'); c.setAttribute('stroke-width', sw);
      if (dash) c.setAttribute('stroke-dasharray', dash);
      if (dashOff !== undefined) c.setAttribute('stroke-dashoffset', dashOff);
      return c;
    }

    var track   = mkCircle('vk__track', ringR, strokeW, trackLen + ' ' + circ);
    var fill    = mkCircle('vk__fill',  ringR, strokeW, fillLen + ' ' + circ);
    fill.setAttribute('stroke', color);
    var outerRg = mkCircle('vk__outer-ring', (VK_SIZE/2)-1.5, 1);
    var sep     = mkCircle('vk__sep', (VK_SIZE/2)*INNER_RATIO, 1);
    svg.appendChild(track); svg.appendChild(fill);
    svg.appendChild(outerRg); svg.appendChild(sep);

    var inner = document.createElement('div'); inner.className = 'vk__inner';

    // SVG needle inside the inner ball — drawn directly in SVG so no CSS overflow/z-index issues
    var cx = VK_SIZE / 2, cy = VK_SIZE / 2;
    var innerR = (VK_SIZE / 2) * INNER_RATIO;
    var indicatorG = document.createElementNS(ns, 'g');
    indicatorG.setAttribute('class', 'vk__indicator');
    indicatorG.setAttribute('transform', 'rotate(' + paramDeg + ',' + cx + ',' + cy + ')');
    var needle = document.createElementNS(ns, 'line');
    needle.setAttribute('x1', String(cx));
    needle.setAttribute('y1', String(cy + 5));
    needle.setAttribute('x2', String(cx));
    needle.setAttribute('y2', String(cy - innerR + 5));
    needle.setAttribute('stroke', color);
    needle.setAttribute('stroke-width', '2.5');
    needle.setAttribute('stroke-linecap', 'round');
    var needleGlow = document.createElementNS(ns, 'line');
    needleGlow.setAttribute('x1', String(cx));
    needleGlow.setAttribute('y1', String(cy + 5));
    needleGlow.setAttribute('x2', String(cx));
    needleGlow.setAttribute('y2', String(cy - innerR + 5));
    needleGlow.setAttribute('stroke', color);
    needleGlow.setAttribute('stroke-width', '5');
    needleGlow.setAttribute('stroke-linecap', 'round');
    needleGlow.setAttribute('opacity', '0.3');
    indicatorG.appendChild(needleGlow);
    indicatorG.appendChild(needle);
    svg.appendChild(indicatorG);

    body.appendChild(svg); body.appendChild(inner);

    // Labels
    var labels = document.createElement('div'); labels.className = 'vk__labels';
    var mixLbl = document.createElement('span'); mixLbl.className = 'vk__lbl vk__lbl--mix';
    mixLbl.style.color = color;
    mixLbl.textContent = Math.round(initVol * 100) + '%';
    var paramLbl = document.createElement('span'); paramLbl.className = 'vk__lbl vk__lbl--param';
    paramLbl.textContent = pMax <= 2 ? '' : (initParam >= 1000 ? (initParam/1000).toFixed(1)+'k' : Math.round(initParam) + (pMax > 3 ? 's' : ''));
    labels.appendChild(mixLbl); labels.appendChild(paramLbl);

    container.innerHTML = ''; container.appendChild(body); container.appendChild(labels);

    // Drag interaction
    var draggingZone = null, startVol = initVol, startParam = initParam, lastY = 0;

    function getZone(e) {
      var rect = body.getBoundingClientRect();
      var dx = e.clientX - (rect.left + rect.width/2);
      var dy = e.clientY - (rect.top + rect.height/2);
      return Math.sqrt(dx*dx + dy*dy) < (rect.width/2) * INNER_RATIO ? 'inner' : 'outer';
    }
    function updateTooltip(zone) {
      body.title = zone === 'inner' ? paramLabel : 'Volume';
    }
    function updateFill(v) {
      var fl = (v * ANGLE_RANGE / 360) * circ;
      fill.setAttribute('stroke-dasharray', fl + ' ' + circ);
      mixLbl.textContent = Math.round(v * 100) + '%';
    }
    function updateParam(v) {
      var ratio = Math.max(0, Math.min(1, (v - pMin) / (pMax - pMin)));
      var deg = MIN_ANGLE + ratio * ANGLE_RANGE;
      indicatorG.setAttribute('transform', 'rotate(' + deg + ',' + cx + ',' + cy + ')');
      if (pMax <= 2) {
        // type selector — no text label needed, handled by outer state
      } else {
        paramLbl.textContent = v >= 1000 ? (v/1000).toFixed(1)+'k' : Math.round(v) + (pMax > 3 ? 's' : '');
      }
    }

    body.addEventListener('pointerdown', function(e) {
      draggingZone = getZone(e);
      body.dataset.zone = draggingZone;
      updateTooltip(draggingZone);
      startVol = initVol; startParam = initParam;
      lastY = e.clientY;
      body.setPointerCapture(e.pointerId);
      e.preventDefault();
    });
    body.addEventListener('pointermove', function(e) {
      if (!draggingZone) {
        var zone = getZone(e);
        body.dataset.zone = zone;
        updateTooltip(zone);
        return;
      }
      // Compute delta from raw clientY rather than e.movementY — movementY
      // is unreliable on touch-originated PointerEvents in several mobile
      // browsers (reports 0 every step), which made dragging a no-op there.
      var dy = e.clientY - lastY;
      lastY = e.clientY;
      if (draggingZone === 'outer') {
        initVol = Math.max(0, Math.min(1, startVol - dy / 200));
        startVol = initVol;
        updateFill(initVol);
        onVol(initVol);
      } else {
        initParam = Math.max(pMin, Math.min(pMax, startParam - (dy / 200) * (pMax - pMin)));
        startParam = initParam;
        updateParam(initParam);
        onParam(initParam);
      }
    });
    body.addEventListener('pointerup',     function() { draggingZone = null; body.dataset.zone = ''; });
    body.addEventListener('pointercancel', function() { draggingZone = null; body.dataset.zone = ''; });
    body.addEventListener('pointerleave',  function() { if (!draggingZone) body.dataset.zone = ''; });

    return { updateFill: updateFill, updateParam: updateParam };
  }


  function initSynthControls() {
    var panel = document.getElementById('vz-synth-controls');
    if (!panel) return;
    // Always un-minimize when vibe is re-activated so controls are visible
    panel.classList.remove('vzc-minimized');
    panel.removeAttribute('hidden');
    // Animate panel expanding in
    panel.classList.remove('vzc-entering');
    void panel.offsetWidth; // force reflow so animation re-triggers
    panel.classList.add('vzc-entering');
    panel.addEventListener('animationend', function() { panel.classList.remove('vzc-entering'); }, { once: true });

    // Inject header (minimize + QR share) — idempotent guard
    if (!panel.querySelector('.vzc-header')) {
      var hdr = document.createElement('div');
      hdr.className = 'vzc-header';
      hdr.innerHTML =
        '<span class="vzc-header__title">vibe</span>' +
        '<canvas class="vzc-sine-wave" width="72" height="14"></canvas>' +
        '<button class="vzc-header__qr" title="share vibe" aria-label="Share vibe QR">◉</button>' +
        '<button class="vzc-header__min" title="minimize" aria-label="Minimize controls">−</button>';
      panel.insertBefore(hdr, panel.firstChild);

      var sineEl = hdr.querySelector('.vzc-sine-wave');
      var minBtn = hdr.querySelector('.vzc-header__min');
      minBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var min = panel.classList.toggle('vzc-minimized');
        minBtn.textContent = min ? '+' : '−';
        minBtn.title = min ? 'expand' : 'minimize';
        if (min) {
          startSineWave(sineEl);
          // Restore smoke + normal layout when minimized
          var sw = document.getElementById('vz-smoke-wrap');
          if (sw) sw.removeAttribute('hidden');
          if (vzSection) vzSection.classList.remove('vz--synth-open');
        } else {
          stopSineWave();
          if (synthVisOn && !circleAF) startCircleViz();
          // Hide smoke + full-screen layout when expanded
          var sw = document.getElementById('vz-smoke-wrap');
          if (sw) sw.setAttribute('hidden', '');
          if (vzSection) vzSection.classList.add('vz--synth-open');
        }
      });
      // Click anywhere on minimized pill to expand
      panel.addEventListener('click', function(e) {
        if (!panel.classList.contains('vzc-minimized')) return;
        panel.classList.remove('vzc-minimized');
        stopSineWave();
        var mb = panel.querySelector('.vzc-header__min');
        if (mb) { mb.textContent = '−'; mb.title = 'minimize'; }
        if (synthVisOn && !circleAF) startCircleViz();
        // Hide smoke + full-screen layout when expanding from pill
        var sw = document.getElementById('vz-smoke-wrap');
        if (sw) sw.setAttribute('hidden', '');
        if (vzSection) vzSection.classList.add('vz--synth-open');
      });
      hdr.querySelector('.vzc-header__qr').addEventListener('click', function(e) {
        e.stopPropagation();
        openQR();
      });
    } else {
      // Header exists — sync minimize button text if not minimized
      var existingMin = panel.querySelector('.vzc-header__min');
      if (existingMin) { existingMin.textContent = '−'; existingMin.title = 'minimize'; }
    }

    panel.querySelectorAll('.vzc-slot').forEach(function(slot) {
      var id   = slot.dataset.sound;
      var kind = slot.dataset.kind;
      var pMin = parseFloat(slot.dataset.pmin || 0);
      var pMax = parseFloat(slot.dataset.pmax || 1);
      var pDef = parseFloat(slot.dataset.pdef || 0);
      var vDef = parseFloat(slot.dataset.vdef || 0.5);

      var state = kind === 'noise' ? synthNoise[id] :
                  kind === 'periodic' ? synthTones[id] : synthElem[id];
      if (!state) return;

      slot.classList.toggle('vzc-on', !!state.on);

      // Slot click — guard against duplicate listeners across re-inits
      if (!slot._vzInit) {
        slot._vzInit = true;
        slot.addEventListener('click', function(e) {
          if (e.target.closest('.vk__body')) return;
          state.on = !state.on;
          slot.classList.toggle('vzc-on', state.on);
          if (state.on) startSoundById(id, kind, state);
          else stopSoundById(id, kind);
        });
      }

      // For elemental slots, build trigram display before knob — guard against duplicates
      var triSvgEl = null, triLblEl = null;
      if (kind === 'elemental') {
        var existingTri = slot.querySelector('.vzc-trigram');
        if (existingTri) {
          triSvgEl = existingTri.querySelector('svg');
          triLblEl = existingTri.querySelector('.vzc-trigram__label');
        } else {
          var elemColor = slot.style.getPropertyValue('--vzc-color') || '#aaa';
          var triWrap = document.createElement('div');
          triWrap.className = 'vzc-trigram';
          triSvgEl = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          triSvgEl.setAttribute('width', '22'); triSvgEl.setAttribute('height', '21');
          triSvgEl.setAttribute('viewBox', '0 0 22 21');
          drawTrigramSVG(triSvgEl, triMorphLines(id, state.type), elemColor);
          triLblEl = document.createElement('span');
          triLblEl.className = 'vzc-trigram__label';
          triLblEl.textContent = triName(id, state.type);
          triWrap.appendChild(triSvgEl);
          triWrap.appendChild(triLblEl);
          slot.appendChild(triWrap);
        }
      }

      // Build DualKnob
      var vkContainer = slot.querySelector('[data-vk]');
      if (vkContainer) {
        var initVol   = state.vol   !== undefined ? state.vol   : vDef;
        var initParam = kind === 'noise' ? state.freq : kind === 'periodic' ? state.rate : state.type;
        if (initParam === undefined) initParam = pDef;

        // Interacting with an inactive slot's knob should turn it on, same
        // as clicking the card itself — grabbing the dial shouldn't be a
        // dead end. Attached to the container (not the knob body) so it
        // survives buildKnob's innerHTML reset below.
        if (!vkContainer._vzKnobEnable) {
          vkContainer._vzKnobEnable = true;
          vkContainer.addEventListener('pointerdown', function() {
            if (!state.on) {
              state.on = true;
              slot.classList.add('vzc-on');
              startSoundById(id, kind, state);
            }
          }, true);
        }

        var paramLabel = kind === 'noise' ? 'Frequency' : kind === 'periodic' ? 'Rate' : 'Type';
        buildKnob(vkContainer, slot.style.getPropertyValue('--vzc-color') || '#aaa',
          initVol, initParam, pMin, pMax,
          function(v) {
            state.vol = v;
            if (state.node) state.node.gain.gain.value = v;
          },
          function(v) {
            if (kind === 'noise') {
              state.freq = v;
              if (state.node && state.node.filter) state.node.filter.frequency.value = v;
            } else if (kind === 'periodic') {
              state.rate = v;
            } else {
              var newType = Math.round(v);
              if (newType !== state.type) {
                state.type = newType;
                if (state.on) { stopSoundById(id, kind); startSoundById(id, kind, state); }
              }
              // Morph trigram continuously as inner knob drags
              if (triSvgEl) drawTrigramSVG(triSvgEl, triMorphLines(id, v), slot.style.getPropertyValue('--vzc-color') || '#aaa');
              if (triLblEl) triLblEl.textContent = triName(id, v);
            }
          },
          paramLabel
        );
      }
    });

  }

  function startSoundById(id, kind, state) {
    if (!synthCtx) return;
    stopSoundById(id, kind); // ensure clean start
    var node = null;
    if (kind === 'noise') {
      if (id === 'white') node = makeWhiteNoise(synthCtx, state.freq);
      else if (id === 'pink') node = makePinkNoiseNode(synthCtx, state.freq);
      else if (id === 'blue') node = makeBlueNoise(synthCtx, state.freq);
      if (node) { node.gain.gain.value = state.vol; node.gain.connect(synthMaster); state.node = node; }
    } else if (kind === 'elemental') {
      var t = state.type;
      if (id === 'fire')  node = t === 0 ? makeCandle(synthCtx) : makeCandle(synthCtx); // variants use same for now
      else if (id === 'water') node = makeWater(synthCtx);
      else if (id === 'wind')  node = makeWind(synthCtx);
      else if (id === 'earth') node = makeEarth(synthCtx);
      if (node) { node.gain.gain.value = state.vol; node.gain.connect(synthMaster); state.node = node; }
    }
    // periodic: handled by scheduling loops which check state.on
  }

  function stopSoundById(id, kind) {
    var state = kind === 'noise' ? synthNoise[id] :
                kind === 'periodic' ? synthTones[id] : synthElem[id];
    if (state && state.node) {
      state.node.stop();
      try { state.node.gain.disconnect(); } catch(e) {}
      state.node = null;
    }
  }

  // keep legacy stubs so existing startSynth/stopSynth references still compile
  var synthSoundNodes = {};
  function startSoundNode(id) {}
  function stopSoundNode(id) {}

  function startSynth() {
    synthVisOn = true;
    synthCtx    = new (window.AudioContext || window.webkitAudioContext)();
    synthMaster = synthCtx.createGain();
    synthMaster.gain.value = 0.7;
    synthMaster.connect(synthCtx.destination);

    synthReverb = makeReverb(synthCtx);
    synthReverb.connect(synthMaster);
    var reverb = synthReverb;

    // Start initially-enabled elemental sounds
    Object.keys(synthElem).forEach(function(id) {
      var st = synthElem[id];
      if (st.on) startSoundById(id, 'elemental', st);
    });
    // Start initially-enabled noise
    Object.keys(synthNoise).forEach(function(id) {
      var st = synthNoise[id];
      if (st.on) startSoundById(id, 'noise', st);
    });

    initSynthControls();
    startCircleViz();
    resizeBg();
    var smokeWrap = document.getElementById('vz-smoke-wrap');
    if (smokeWrap) smokeWrap.setAttribute('hidden', '');
    if (vzSection) vzSection.classList.add('vz--synth-open');

    // Background ripple pulses
    function schedFireRipple() {
      if (!synthVisOn) return;
      if (synthElem.fire.on) triggerRipple(GLOW_FIRE, 'flower', 3);
      synthTimers.push(setTimeout(schedFireRipple, 6000 + Math.random() * 6000));
    }
    synthTimers.push(setTimeout(schedFireRipple, 1000));

    function schedWaterRipple() {
      if (!synthVisOn) return;
      if (synthElem.water.on) triggerRipple(GLOW_RAIN, 'halo');
      synthTimers.push(setTimeout(schedWaterRipple, 8000 + Math.random() * 8000));
    }
    synthTimers.push(setTimeout(schedWaterRipple, 3000));

    // Periodic tone scheduling — uses rate from synthTones state
    function schedChime() {
      if (!synthVisOn) return;
      var t = synthTones.chime;
      if (t.on && t.vol > 0) {
        ringChime(synthCtx, reverb, 0.45 * t.vol / 0.5);
        triggerRipple(GLOW_CHIME, 'flower', 5);
      }
      synthTimers.push(setTimeout(schedChime, t.rate * 1000 * (0.7 + Math.random() * 0.6)));
    }
    schedChime();

    function schedBell() {
      if (!synthVisOn) return;
      var t = synthTones.bell;
      if (t.on && t.vol > 0) {
        var bellFreqs = [220, 261.63, 329.63, 392, 440];
        ringBell(synthCtx, reverb, bellFreqs[Math.floor(Math.random() * bellFreqs.length)], 0.3 * t.vol / 0.5);
        triggerRipple(GLOW_BELL, 'halo');
      }
      synthTimers.push(setTimeout(schedBell, synthTones.bell.rate * 1000 * (0.7 + Math.random() * 0.6)));
    }
    schedBell();

    // Gong — less frequent
    function schedGong() {
      if (!synthVisOn) return;
      var g = synthTones.gong;
      if (g.on && g.vol > 0) {
        triggerGong(synthCtx, reverb, 0.6 * g.vol / 0.5);
        triggerRipple(GLOW_FIRE, 'flower', 6);
      }
      synthTimers.push(setTimeout(schedGong, g.rate * 1000 * (0.7 + Math.random() * 0.6)));
    }
    schedGong();

    function schedBirds() {
      if (!synthVisOn) return;
      var b = synthTones.birds;
      if (b.on && b.vol > 0) {
        triggerBirds(synthCtx, reverb, 0.5 * b.vol / 0.5);
        triggerRipple(GLOW_RAIN, 'flower', 8);
      }
      synthTimers.push(setTimeout(schedBirds, synthTones.birds.rate * 1000 * (0.7 + Math.random() * 0.6)));
    }
    schedBirds();
  }

  function stopSynth() {
    stopAudioInput();
    synthVisOn = false;
    synthTimers.forEach(function(t) { clearTimeout(t); clearInterval(t); });
    synthTimers = []; synthNodes = [];
    // Stop all elemental nodes
    Object.keys(synthElem).forEach(function(id) {
      if (synthElem[id].node) { synthElem[id].node.stop(); try { synthElem[id].node.gain.disconnect(); } catch(e){} synthElem[id].node = null; }
    });
    // Stop all noise nodes
    Object.keys(synthNoise).forEach(function(id) {
      if (synthNoise[id].node) { synthNoise[id].node.stop(); try { synthNoise[id].node.gain.disconnect(); } catch(e){} synthNoise[id].node = null; }
    });
    stopSineWave();
    var panel = document.getElementById('vz-synth-controls');
    if (panel) panel.setAttribute('hidden', '');
    var smokeWrapOff = document.getElementById('vz-smoke-wrap');
    if (smokeWrapOff) smokeWrapOff.removeAttribute('hidden');
    if (vzSection) vzSection.classList.remove('vz--synth-open');
    stopCircleViz();
    if (synthCtx) { synthCtx.close(); synthCtx = null; synthMaster = null; synthReverb = null; }
    setTimeout(resizeBg, 50);
  }

  // ── Circle viz (radial spectrum, shown when vibe synth active) ──────────────
  var circleCanvas = document.getElementById('vz-circle-viz');
  var circleCtx    = circleCanvas ? circleCanvas.getContext('2d') : null;
  var circleAF     = null;
  var circleAnalyser = null;

  // ── Sine wave on minimized pill ──────────────────────────────────────────────
  var sineWaveAF = null;

  function startSineWave(canvas) {
    if (sineWaveAF) return;
    function tick() {
      var panel = document.getElementById('vz-synth-controls');
      if (!canvas || !panel || !panel.classList.contains('vzc-minimized')) {
        sineWaveAF = null; return;
      }
      sineWaveAF = requestAnimationFrame(tick);
      var ctx2 = canvas.getContext('2d');
      var W2 = canvas.width, H2 = canvas.height;
      ctx2.clearRect(0, 0, W2, H2);
      var t2 = performance.now() / 1000;
      var amp = (H2 / 2 - 1) * (0.65 + Math.sin(t2 * 1.1) * 0.35);
      ctx2.beginPath();
      for (var xi = 0; xi <= W2; xi++) {
        var yi = H2 / 2 + Math.sin((xi / W2) * Math.PI * 5 + t2 * 3.2) * amp;
        if (xi === 0) ctx2.moveTo(xi, yi); else ctx2.lineTo(xi, yi);
      }
      ctx2.strokeStyle = 'rgba(255, 195, 100, 0.75)';
      ctx2.lineWidth = 1.4;
      ctx2.stroke();
    }
    tick();
  }

  function stopSineWave() {
    if (sineWaveAF) { cancelAnimationFrame(sineWaveAF); sineWaveAF = null; }
  }

  function startCircleViz() {
    if (!circleCanvas || !synthCtx || !synthMaster) return;
    if (circleAF) return; // already running

    // Tap analyser: synthMaster → analyser → silent gain → destination
    // (zero-gain sink keeps the analyser in the rendering graph without doubling audio)
    circleAnalyser = synthCtx.createAnalyser();
    circleAnalyser.fftSize = 256;
    circleAnalyser.smoothingTimeConstant = 0.8;
    var analyserSink = synthCtx.createGain();
    analyserSink.gain.value = 0;
    synthMaster.connect(circleAnalyser);
    circleAnalyser.connect(analyserSink);
    analyserSink.connect(synthCtx.destination);

    var S = 280;
    circleCanvas.width = S; circleCanvas.height = S;
    circleCanvas.removeAttribute('hidden');

    var fdata = new Uint8Array(circleAnalyser.frequencyBinCount);
    var BARS = 72;
    var cx = S / 2, cy = S / 2;
    var maxR = cx * 0.87, minR = cx * 0.28;

    function draw() {
      if (!synthVisOn) return;
      circleAF = requestAnimationFrame(draw);
      circleAnalyser.getByteFrequencyData(fdata);
      circleCtx.clearRect(0, 0, S, S);

      var step = Math.floor(fdata.length * 0.5 / BARS);
      for (var i = 0; i < BARS; i++) {
        var val = fdata[i * step] / 255;
        var angle = (i / BARS) * Math.PI * 2 - Math.PI / 2;
        var r = minR + val * (maxR - minR);
        var hue = 190 + i * 2;
        circleCtx.beginPath();
        circleCtx.moveTo(cx + Math.cos(angle) * minR, cy + Math.sin(angle) * minR);
        circleCtx.lineTo(cx + Math.cos(angle) * r,    cy + Math.sin(angle) * r);
        circleCtx.strokeStyle = 'hsla(' + hue + ',65%,62%,' + (0.35 + val * 0.6) + ')';
        circleCtx.lineWidth   = (Math.PI * 2 * minR / BARS) * 0.52;
        circleCtx.stroke();
      }

      var avg = 0;
      for (var j = 0; j < fdata.length; j++) avg += fdata[j];
      avg = avg / fdata.length / 255;
      circleCtx.beginPath();
      circleCtx.arc(cx, cy, minR * 0.35, 0, Math.PI * 2);
      circleCtx.fillStyle = 'rgba(255,255,255,' + (0.05 + avg * 0.12) + ')';
      circleCtx.fill();
    }
    draw();
  }

  function stopCircleViz() {
    if (circleAF) { cancelAnimationFrame(circleAF); circleAF = null; }
    if (circleCanvas) { circleCanvas.setAttribute('hidden', ''); }
    if (circleAnalyser) {
      try { circleAnalyser.disconnect(); } catch(e){}
      circleAnalyser = null;
    }
    if (circleCtx && circleCanvas) circleCtx.clearRect(0, 0, circleCanvas.width, circleCanvas.height);
  }

  // ── QR share modal ───────────────────────────────────────────────────────────
  var QR_DEFAULT_GRADIENT = [
    { offset: 0,    color: [100, 40,255] },
    { offset: 0.15, color: [  0,180,255] },
    { offset: 0.3,  color: [ 30,255,200] },
    { offset: 0.48, color: [255,100,200] },
    { offset: 0.65, color: [255,155, 40] },
    { offset: 0.82, color: [ 40,200,255] },
    { offset: 1,    color: [100, 40,255] },
  ];

  function qrLerpColor(stops, t) {
    t = Math.max(0, Math.min(1, t));
    for (var i = 0; i < stops.length - 1; i++) {
      if (t >= stops[i].offset && t <= stops[i+1].offset) {
        var u = (t - stops[i].offset) / (stops[i+1].offset - stops[i].offset);
        return stops[i].color.map(function(c, j) { return Math.round(c + (stops[i+1].color[j] - c) * u); });
      }
    }
    return stops[stops.length-1].color;
  }

  function qrGradientFromGlows(glows) {
    var rgb = glows.map(function(c) {
      var m = c.match(/[\d.]+/g);
      return m ? [parseInt(m[0]), parseInt(m[1]), parseInt(m[2])] : [100,40,255];
    });
    return rgb.map(function(c, i) { return { offset: i / (rgb.length - 1 || 1), color: c }; });
  }

  function getActiveGlows() {
    var g = [];
    ['fire','wind','water','earth'].forEach(function(id) { if (synthElem[id] && synthElem[id].on) g.push(SOUND_GLOWS[id]); });
    ['bell','chime','gong','birds'].forEach(function(id) { if (synthTones[id] && synthTones[id].on) g.push(SOUND_GLOWS[id]); });
    ['white','pink','blue'].forEach(function(id) { if (synthNoise[id] && synthNoise[id].on) g.push(SOUND_GLOWS[id]); });
    return g;
  }

  function buildVibeURL(name) {
    var u = new URL(window.location.href);
    var active = [];
    ['fire','wind','water','earth'].forEach(function(id) { if (synthElem[id] && synthElem[id].on) active.push(id); });
    ['bell','chime','gong','birds'].forEach(function(id) { if (synthTones[id] && synthTones[id].on) active.push(id); });
    ['white','pink','blue'].forEach(function(id) { if (synthNoise[id] && synthNoise[id].on) active.push(id); });
    if (active.length) u.searchParams.set('s', active.join('-'));
    if (name && name.trim()) u.searchParams.set('p', name.trim());
    return u.toString();
  }

  function drawVibeQR(canvas, url, name, seed, glows) {
    if (!window.QRCode || !window.QRCode.toCanvas) return;
    var QR = 220, sp = 18;
    var nameH = name && name.trim() ? 28 : 0;
    var W = QR + sp * 2, H = QR + sp * 2 + nameH;
    canvas.width = W; canvas.height = H;

    var gradient = glows && glows.length >= 2 ? qrGradientFromGlows(glows) : QR_DEFAULT_GRADIENT;

    var tmp = document.createElement('canvas');
    window.QRCode.toCanvas(tmp, url, {
      width: QR, margin: 2,
      color: { dark: '#000000', light: '#00000000' },
      errorCorrectionLevel: 'M',
    }, function() {
      var ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = '#010206';
      ctx.fillRect(0, 0, W, H);

      // Read raw pixel data from the tmp canvas (transparent bg, dark modules opaque)
      var rawCtx = tmp.getContext('2d');
      var rawData = rawCtx.getImageData(0, 0, QR, QR);
      var d = rawData.data;
      var off = (seed || 0) % 1;

      for (var y = 0; y < QR; y++) {
        for (var x = 0; x < QR; x++) {
          var ix = (y * QR + x) * 4;
          if (d[ix + 3] > 128) {
            var cx_ = x / QR - 0.5, cy_ = y / QR - 0.5;
            var ang  = Math.atan2(cy_, cx_) / (Math.PI * 2) + 0.5;
            var dist = Math.sqrt(cx_*cx_ + cy_*cy_) * 2;
            var t    = (ang * 0.55 + dist * 0.45 + (x + y) / (QR * 3) + off) % 1;
            var col  = qrLerpColor(gradient, t);
            d[ix] = col[0]; d[ix+1] = col[1]; d[ix+2] = col[2]; d[ix+3] = 255;
          } else {
            d[ix+3] = 0;
          }
        }
      }

      var colored = document.createElement('canvas');
      colored.width = QR; colored.height = QR;
      colored.getContext('2d').putImageData(rawData, 0, 0);
      ctx.drawImage(colored, sp, sp);

      // Edge glow
      var c0 = qrLerpColor(gradient, 0), c1 = qrLerpColor(gradient, 0.5);
      ctx.save(); ctx.translate(sp, sp);
      var gGrad = ctx.createRadialGradient(QR/2, QR/2, QR*0.3, QR/2, QR/2, QR*0.65);
      gGrad.addColorStop(0,   'rgba('+c0[0]+','+c0[1]+','+c0[2]+',0)');
      gGrad.addColorStop(0.7, 'rgba('+c1[0]+','+c1[1]+','+c1[2]+',0.06)');
      gGrad.addColorStop(1,   'rgba('+c0[0]+','+c0[1]+','+c0[2]+',0.14)');
      ctx.globalCompositeOperation = 'screen';
      ctx.fillStyle = gGrad;
      ctx.fillRect(-sp, -sp, W, H);
      ctx.globalCompositeOperation = 'source-over';
      ctx.restore();

      // Name label below QR
      if (name && name.trim() && nameH > 0) {
        var txt = name.trim();
        var fs  = Math.min(13, Math.max(9, Math.floor(W / (txt.length * 0.9))));
        ctx.font = 'bold ' + fs + 'px monospace';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        var ty = sp + QR + nameH / 2;
        var cr = qrLerpColor(gradient, 0.22);
        ctx.fillStyle = 'rgb('+cr[0]+','+cr[1]+','+cr[2]+')';
        ctx.shadowColor = 'rgba('+cr[0]+','+cr[1]+','+cr[2]+',0.85)';
        ctx.shadowBlur = 7;
        ctx.fillText(txt, W / 2, ty);
        ctx.shadowBlur = 0;
      }
    });
  }

  var _qrSeed = Math.random();

  function openQR() {
    var modal = document.getElementById('vz-qr-modal');
    if (!modal) return;
    modal.removeAttribute('hidden');

    var canvas = document.getElementById('vz-qr-canvas');
    var nameEl = document.getElementById('vz-qr-name');
    var copyEl = document.getElementById('vz-qr-copy');
    var saveEl = document.getElementById('vz-qr-save');
    var closeEl = document.getElementById('vz-qr-close');
    var shakeEl = document.getElementById('vz-qr-shake');
    var backdrop = document.getElementById('vz-qr-backdrop');

    function refresh() {
      var url  = buildVibeURL(nameEl ? nameEl.value : '');
      var name = nameEl ? nameEl.value : '';
      drawVibeQR(canvas, url, name, _qrSeed, getActiveGlows());
    }
    refresh();

    function onClose() { modal.setAttribute('hidden', ''); }
    function onShake() { _qrSeed = Math.random(); refresh(); }

    if (closeEl)   { closeEl.onclick   = onClose; }
    if (backdrop)  { backdrop.onclick  = onClose; }
    if (shakeEl)   { shakeEl.onclick   = onShake; }
    if (nameEl)    { nameEl.oninput    = refresh; }

    if (copyEl) {
      copyEl.onclick = function() {
        var url = buildVibeURL(nameEl ? nameEl.value : '');
        navigator.clipboard.writeText(url).then(function() {
          copyEl.textContent = 'copied!';
          setTimeout(function() { copyEl.textContent = 'copy link'; }, 2000);
        });
      };
    }
    if (saveEl) {
      saveEl.onclick = function() {
        var pad = 20;
        var dl = document.createElement('canvas');
        dl.width  = canvas.width  + pad * 2;
        dl.height = canvas.height + pad * 2;
        var c = dl.getContext('2d');
        c.fillStyle = '#010206'; c.fillRect(0, 0, dl.width, dl.height);
        c.drawImage(canvas, pad, pad);
        var a = document.createElement('a');
        var nm = nameEl && nameEl.value.trim() ? '-' + nameEl.value.trim().replace(/\s+/g, '-').toLowerCase() : '';
        a.download = 'vibe' + nm + '.png';
        a.href = dl.toDataURL('image/png');
        a.click();
      };
    }

    var escHandler = function(e) { if (e.key === 'Escape') { onClose(); window.removeEventListener('keydown', escHandler); } };
    window.addEventListener('keydown', escHandler);
  }

  // ── 6. Bug game ─────────────────────────────────────────────────────────────
  var gameCanvas  = document.getElementById('vz-game');
  var gCtx        = gameCanvas ? gameCanvas.getContext('2d') : null;
  var gameAF      = null;
  var gameOn      = false;
  var bugs        = [];
  var smoke       = [];
  var mx = 0, my = 0;
  var driven = 0;      // bugs chased off screen
  var landedCount = 0; // cached count of landed bugs (updated incrementally)
  var NBUG = 14;
  var BOSS_EVERY = 9;  // spawn boss after every N driven
  var fsEnteredByGame = false; // true if buggone itself triggered real fullscreen
  var SMOKE_TRAIL_CHARS = ['✦', '∿', '~', '○', '°', '✧', '❋'];

  var gameCloseBtn = document.getElementById('vz-game-close');
  if (gameCloseBtn) {
    gameCloseBtn.addEventListener('click', function () {
      active.buggone = false;
      var el = document.getElementById('vz-buggone');
      if (el) el.classList.remove('vz-obj--active');
      stopBugs();
    });
  }

  function startBugs() {
    if (!gameCanvas) return;
    gameCanvas.removeAttribute('hidden');
    if (gameCloseBtn) gameCloseBtn.removeAttribute('hidden');
    gameCanvas.width  = gameCanvas.offsetWidth  || vzSection.offsetWidth;
    gameCanvas.height = window.innerHeight;
    // Game mode: shrink objects, disable proximity hover
    if (vzSection) vzSection.classList.add('vz--game-mode');

    // This click is a real user gesture — enter true browser fullscreen.
    // Only exit it on close if the game itself caused the entry (don't
    // yank the user out of fullscreen they turned on manually beforehand).
    fsEnteredByGame = fsSupported && !isRealFullscreen();
    enterRealFullscreen();

    // Buggone always plays out against a dark sky so the daytime-lightening
    // overlay (as bugs are driven off) reads clearly — restore theme on close.
    vzDayBeforeGame = vzDay;
    if (vzDay) {
      vzDay = false;
      document.body.classList.remove('vz-day');
      // Toggle itself keeps showing "day" (per vzDayBeforeGame) even though
      // the page bg stays dark for gameplay — only the aria state, not the
      // visual, would otherwise flip here.
    }

    driven = 0; landedCount = 0; bugs = []; smoke = [];
    for (var i = 0; i < NBUG; i++) bugs.push(newBug());
    // Listen on the SECTION (not canvas) so mouse over z-index-12 objects
    // at the bottom still triggers the wand — canvas won't get events there
    (vzSection || gameCanvas).addEventListener('mousemove', onGameMouse);
    (vzSection || gameCanvas).addEventListener('click', onGameClick);
    // Mobile: mousemove/click never fire from touch drags, so the wand just
    // sat frozen on mobile. touchmove drives wand tracking (with preventDefault
    // so dragging the wand doesn't scroll the page); touchstart fires the same
    // ember-flare burst a mouse click does.
    (vzSection || gameCanvas).addEventListener('touchstart', onGameTouchStart, { passive: false });
    (vzSection || gameCanvas).addEventListener('touchmove',  onGameTouchMove,  { passive: false });
    gameOn = true;
    bugLoop();
  }

  var WAND_LEN = 58; // wand extends up from cursor by this many px
  var clickGlowT = 0; // frames remaining for click ember flash

  function onGameClick() {
    if (!gameOn) return;
    clickGlowT = 14; // brief ember flare
    var tipX = mx, tipY = my - WAND_LEN;
    for (var b = 0; b < 11; b++) {
      var angle = (b / 11) * Math.PI * 2 + Math.random() * 0.5;
      var speed = 0.9 + Math.random() * 1.8;
      smoke.push({
        x: tipX + (Math.random() - 0.5) * 6,
        y: tipY,
        vx: Math.cos(angle) * speed * 0.55,
        vy: -Math.abs(Math.sin(angle) * speed * 0.8) - 0.5,
        ch: SMOKE_TRAIL_CHARS[Math.floor(Math.random() * SMOKE_TRAIL_CHARS.length)],
        life: 1,
        dec: 0.007 + Math.random() * 0.009,
        sz: 12 + Math.random() * 10,
      });
    }
  }

  function onGameTouchStart(e) {
    if (!gameOn || !e.touches.length) return;
    // Don't hijack taps on the close button or the (small, still-tappable
    // during a game) object buttons — only the wand/canvas area should
    // preventDefault and suppress their native tap-to-click.
    if (e.target.closest('.vz-game-close, .vz-obj')) return;
    e.preventDefault();
    onGameMouse(e.touches[0]);
    onGameClick();
  }

  function onGameTouchMove(e) {
    if (!gameOn || !e.touches.length) return;
    if (e.target.closest('.vz-game-close, .vz-obj')) return;
    e.preventDefault();
    onGameMouse(e.touches[0]);
  }

  function onGameMouse(e) {
    var r = gameCanvas.getBoundingClientRect();
    // Scale from CSS pixels to canvas buffer pixels (they differ when section is taller than viewport)
    var scaleX = gameCanvas.width  / (r.width  || gameCanvas.width);
    var scaleY = gameCanvas.height / (r.height || gameCanvas.height);
    mx = (e.clientX - r.left) * scaleX;
    my = (e.clientY - r.top)  * scaleY;
    // Emit smoke from TIP of wand (top), not cursor (bottom)
    if (Math.random() < 0.35) {
      smoke.push({
        x: mx, y: my - WAND_LEN,
        vx: (Math.random() - 0.5) * 0.9,
        vy: -(0.6 + Math.random() * 1.1),
        ch: SMOKE_TRAIL_CHARS[Math.floor(Math.random() * SMOKE_TRAIL_CHARS.length)],
        life: 1,
        dec:  0.011 + Math.random() * 0.007,
        sz:   10 + Math.random() * 7,
      });
    }
  }

  function newBug() {
    var W = gameCanvas.width, H = gameCanvas.height;
    var types = ['mosquito', 'gnat', 'moth'];
    var t = types[Math.floor(Math.random() * 3)];
    // Only spawn from top or upper-third of left/right sides — never from bottom
    var side = Math.floor(Math.random() * 3); // 0=top, 1=left-upper, 2=right-upper
    var x, y;
    if      (side === 0) { x = Math.random() * W; y = -25; }
    else if (side === 1) { x = -25; y = Math.random() * H * 0.4; }
    else                  { x = W + 25; y = Math.random() * H * 0.4; }
    return {
      t: t, x: x, y: y,
      vx: (Math.random() - 0.5) * 1.2,
      vy: (Math.random() - 0.5) * 1.2 + 0.2,
      sz: t === 'gnat' ? 7 : t === 'moth' ? 11 : 13,
      a:  Math.random() * Math.PI * 2,
      da: (Math.random() - 0.5) * 0.08,
      flee: false,
      landed: false,
    };
  }

  function drawBug(b, day) {
    gCtx.save();
    gCtx.translate(b.x, b.y);
    gCtx.rotate(b.a);
    var isBoss = b.isBoss;
    // As the screen lightens (day → 1) pastel strokes wash out against the
    // brightening overlay, so shift toward darker, more saturated tones.
    var lit = day > 0.4;
    var col = isBoss
      ? (b.flee ? 'rgba(255,200,80,0.95)' : 'rgba(255,160,40,0.85)')
      : (b.flee
          ? (lit ? 'rgba(20,110,25,0.9)'  : 'rgba(160,255,140,0.85)')
          : (lit ? 'rgba(35,75,40,0.85)'  : 'rgba(160,200,160,0.65)'));
    gCtx.strokeStyle = col;
    gCtx.lineWidth = isBoss ? 2 : (lit ? 1.4 : 1.1);
    // Boss pulsing aura
    if (isBoss) {
      gCtx.save();
      gCtx.rotate(-b.a);
      var aura = gCtx.createRadialGradient(0,0,0,0,0,b.sz*2.2);
      aura.addColorStop(0, 'rgba(255,150,30,0.18)');
      aura.addColorStop(1, 'rgba(255,100,0,0)');
      gCtx.fillStyle = aura;
      gCtx.beginPath(); gCtx.arc(0,0,b.sz*2.2,0,Math.PI*2); gCtx.fill();
      gCtx.restore();
    }
    var s = b.sz;

    if (b.t === 'mosquito') {
      // body
      gCtx.beginPath(); gCtx.ellipse(0, 2, s * 0.35, s * 0.65, 0, 0, Math.PI * 2); gCtx.stroke();
      // head
      gCtx.beginPath(); gCtx.arc(0, -s * 0.55, s * 0.3, 0, Math.PI * 2); gCtx.stroke();
      // proboscis
      gCtx.beginPath(); gCtx.moveTo(0, -s * 0.85); gCtx.lineTo(0, -s * 1.35); gCtx.stroke();
      // wings
      gCtx.beginPath(); gCtx.ellipse(-s * 0.8, -s * 0.1, s * 0.65, s * 0.22, -0.45, 0, Math.PI * 2); gCtx.stroke();
      gCtx.beginPath(); gCtx.ellipse( s * 0.8, -s * 0.1, s * 0.65, s * 0.22,  0.45, 0, Math.PI * 2); gCtx.stroke();
    } else if (b.t === 'gnat') {
      gCtx.beginPath(); gCtx.arc(0, 0, s * 0.4, 0, Math.PI * 2); gCtx.stroke();
      gCtx.beginPath(); gCtx.ellipse(-s * 0.55, -s * 0.1, s * 0.42, s * 0.15, -0.3, 0, Math.PI * 2); gCtx.stroke();
      gCtx.beginPath(); gCtx.ellipse( s * 0.55, -s * 0.1, s * 0.42, s * 0.15,  0.3, 0, Math.PI * 2); gCtx.stroke();
    } else { // moth
      gCtx.beginPath(); gCtx.moveTo(0, -s * 0.75); gCtx.lineTo(-s * 0.28, s * 0.5); gCtx.lineTo(s * 0.28, s * 0.5); gCtx.closePath(); gCtx.stroke();
      gCtx.beginPath(); gCtx.ellipse(-s * 0.85, 0, s * 0.65, s * 0.38, -0.35, 0, Math.PI * 2); gCtx.stroke();
      gCtx.beginPath(); gCtx.ellipse( s * 0.85, 0, s * 0.65, s * 0.38,  0.35, 0, Math.PI * 2); gCtx.stroke();
    }
    gCtx.restore();
  }

  function bugLoop() {
    if (!gameOn) return;
    var W = gameCanvas.width, H = gameCanvas.height;

    // Day-progress (0 = dark night, 1 = bright day)
    var day = Math.min(1, driven / NBUG);

    // Transparent clear so bg canvas (stars, blobs, ripples) shows through
    gCtx.clearRect(0, 0, W, H);

    // Daytime brightness overlay — lightens as bugs are driven away
    if (day > 0) {
      gCtx.fillStyle = 'rgba(255, 215, 120, ' + (day * 0.10).toFixed(3) + ')';
      gCtx.fillRect(0, 0, W, H);
    }
    // Night-loss darkening — cache landed count (updated in bug loop, not recalculated each frame)
    var landedFrac = landedCount / Math.max(1, NBUG);
    if (landedFrac > 0.4) {
      gCtx.fillStyle = 'rgba(0, 5, 25, ' + ((landedFrac - 0.4) * 0.35).toFixed(3) + ')';
      gCtx.fillRect(0, 0, W, H);
    }

    // Draw incense-stick cursor — mouse at handle (bottom), tip/ember at top
    var wandTipY = my - WAND_LEN;
    gCtx.save();
    gCtx.strokeStyle = 'rgba(255, 170, 60, 0.75)';
    gCtx.lineWidth = 2.5;
    gCtx.lineCap = 'round';
    gCtx.beginPath();
    gCtx.moveTo(mx, my);           // handle = cursor position
    gCtx.lineTo(mx, wandTipY);     // tip points up
    gCtx.stroke();
    // ember at tip — flares on click
    if (clickGlowT > 0) {
      clickGlowT--;
      var glowR = 2.5 + clickGlowT * 0.65;
      var glowA = (clickGlowT / 14) * 0.30;
      var glowGrad = gCtx.createRadialGradient(mx, wandTipY, 0, mx, wandTipY, glowR * 2.2);
      glowGrad.addColorStop(0, 'rgba(255, 200, 80, ' + glowA + ')');
      glowGrad.addColorStop(1, 'rgba(255, 80, 10, 0)');
      gCtx.fillStyle = glowGrad;
      gCtx.beginPath(); gCtx.arc(mx, wandTipY, glowR * 2.2, 0, Math.PI * 2); gCtx.fill();
      gCtx.fillStyle = 'rgba(255, 220, 120, 0.95)';
      gCtx.beginPath(); gCtx.arc(mx, wandTipY, glowR, 0, Math.PI * 2); gCtx.fill();
    } else {
      gCtx.fillStyle = 'rgba(255, 100, 30, 0.9)';
      gCtx.beginPath(); gCtx.arc(mx, wandTipY, 2.5, 0, Math.PI * 2); gCtx.fill();
    }
    gCtx.restore();

    // Update + draw smoke particles
    for (var i = smoke.length - 1; i >= 0; i--) {
      var sp = smoke[i];
      sp.x  += sp.vx;
      sp.y  += sp.vy;
      sp.life -= sp.dec;
      if (sp.life <= 0) { smoke.splice(i, 1); continue; }
      gCtx.save();
      gCtx.globalAlpha = sp.life * 0.65;
      gCtx.fillStyle = 'rgba(220, 195, 165, 1)';
      gCtx.font = sp.sz + 'px serif';
      gCtx.textAlign = 'center';
      gCtx.fillText(sp.ch, sp.x, sp.y);
      gCtx.restore();
    }

    // Keep at least a few bugs on screen — don't make the player wait through
    // a respawn delay with nothing left to do
    if (bugs.length < 3) {
      bugs.push(newBug());
    }

    // SMOKE REPEL RADIUS
    var SR = 110;

    // Update + draw bugs
    for (var j = bugs.length - 1; j >= 0; j--) {
      var b = bugs[j];
      var fx = 0, fy = 0;
      b.flee = false;

      smoke.forEach(function (sp) {
        var dx = b.x - sp.x, dy = b.y - sp.y;
        var d  = Math.sqrt(dx * dx + dy * dy);
        if (d < SR && d > 0.1) {
          var f = ((SR - d) / SR) * 3.5;
          fx += (dx / d) * f;
          fy += (dy / d) * f;
          b.flee = true;
        }
      });

      // Center smoke column repulsion — bugs always avoid the rising smoke column
      // Effect is stronger when wand drives them toward center
      var CENTER_R = 90;
      var colDX = b.x - W * 0.5;
      var colD  = Math.abs(colDX);
      if (colD < CENTER_R) {
        var colF = ((CENTER_R - colD) / CENTER_R) * 4.5;
        fx += (colDX > 0 ? 1 : -1) * colF;
        b.flee = true;
      }

      if (b.flee) {
        b.vx += fx * 0.18;
        b.vy += fy * 0.18;
      } else if (!b.landed) {
        // Drift inward + downward
        b.vx += ((W * 0.5 - b.x) / W) * 0.015;
        b.vy += 0.018;
      }

      // Clamp speed
      var spd = Math.sqrt(b.vx * b.vx + b.vy * b.vy);
      var maxSpd = b.flee ? 4.5 : 1.8;
      if (spd > maxSpd) { b.vx = (b.vx / spd) * maxSpd; b.vy = (b.vy / spd) * maxSpd; }

      b.x += b.vx; b.y += b.vy; b.a += b.da;

      // Fled off-screen while fleeing → driven away
      if (b.flee && (b.x < -60 || b.x > W + 60 || b.y < -60 || b.y > H + 60)) {
        if (b.landed) landedCount = Math.max(0, landedCount - 1);
        var wasBoss = b.isBoss;
        var bossX = b.x, bossY = b.y;
        bugs.splice(j, 1);
        driven++;
        // Boss splits into 3 small bugs when cleared
        if (wasBoss) {
          for (var s = 0; s < 3; s++) {
            var mini = newBug();
            mini.x = Math.max(-20, Math.min(W + 20, bossX + (s - 1) * 30));
            mini.y = Math.max(-20, Math.min(H * 0.4, bossY));
            mini.sz = 8; mini.isMini = true;
            bugs.push(mini);
          }
        } else {
          // Every BOSS_EVERY driven, spawn a boss next time
          if (driven % BOSS_EVERY === 0) {
            setTimeout(function() {
              if (!gameOn) return;
              var boss = newBug();
              boss.sz = 26; boss.isBoss = true;
              boss.vx *= 0.5; boss.vy *= 0.5; // boss moves slower
              bugs.push(boss);
            }, 2000);
          }
          var delay = 5000 + Math.random() * 6000;
          setTimeout(function () { if (gameOn) bugs.push(newBug()); }, delay);
        }
        continue;
      }

      // Landed at bottom — kept well above the true bottom edge so there's
      // always room below for the wand cursor to sweep under them
      if (b.y > H - 80 && !b.flee) {
        b.y  = H - 80;
        b.vy = 0;
        b.vx *= 0.92;
        if (!b.landed) { b.landed = true; landedCount++; }
      }

      drawBug(b, day);
    }

    // Sticky bugs-cleared counter — always visible during game
    gCtx.save();
    gCtx.globalAlpha = 0.82;
    gCtx.fillStyle = day > 0.5 ? 'rgba(255,220,80,0.95)' : 'rgba(160,200,255,0.85)';
    gCtx.font = 'bold 18px sans-serif';
    gCtx.textAlign = 'right';
    gCtx.fillText(driven + (driven === 1 ? ' bug cleared' : ' bugs cleared'), W - 18, 38);
    gCtx.restore();

    gameAF = requestAnimationFrame(bugLoop);
  }

  function stopBugs() {
    gameOn = false;
    if (gameAF) cancelAnimationFrame(gameAF);
    if (gameCanvas) {
      gameCanvas.setAttribute('hidden', '');
      (vzSection || gameCanvas).removeEventListener('mousemove', onGameMouse);
      (vzSection || gameCanvas).removeEventListener('click', onGameClick);
      (vzSection || gameCanvas).removeEventListener('touchstart', onGameTouchStart);
      (vzSection || gameCanvas).removeEventListener('touchmove', onGameTouchMove);
    }
    if (gameCloseBtn) gameCloseBtn.setAttribute('hidden', '');
    if (vzSection) vzSection.classList.remove('vz--game-mode');
    bugs = []; smoke = [];

    // Apply whatever theme preference the user set (possibly mid-game)
    vzDay = !!vzDayBeforeGame;
    document.body.classList.toggle('vz-day', vzDay);
    if (dayToggle) {
      dayToggle.setAttribute('aria-checked', vzDay ? 'true' : 'false');
      dayToggle.classList.toggle('is-day', vzDay);
    }
    vzDayBeforeGame = null;

    // Only exit real fullscreen if buggone was the one that triggered it
    if (fsEnteredByGame && isRealFullscreen()) exitRealFullscreen();
    fsEnteredByGame = false;
  }


  // ── Day / Night toggle ────────────────────────────────────────────────────────
  var dayToggle = document.getElementById('vz-day-toggle');
  if (dayToggle) {
    dayToggle.addEventListener('click', function() {
      // Buggone forces a dark sky for the lightening effect — the page bg
      // stays dark, but the toggle itself still visibly flips so the user
      // can see and set their preference for when the game closes.
      if (gameOn) {
        vzDayBeforeGame = !vzDayBeforeGame;
        dayToggle.setAttribute('aria-checked', vzDayBeforeGame ? 'true' : 'false');
        dayToggle.classList.toggle('is-day', vzDayBeforeGame);
        return;
      }
      vzDay = !vzDay;
      dayToggle.setAttribute('aria-checked', vzDay ? 'true' : 'false');
      dayToggle.classList.toggle('is-day', vzDay);
      document.body.classList.toggle('vz-day', vzDay);

      // Brief flash transition overlay
      var flash = document.createElement('div');
      flash.className = 'vz-theme-flash';
      document.body.appendChild(flash);
      requestAnimationFrame(function() {
        flash.classList.add('vz-theme-flash--active');
        setTimeout(function() {
          flash.classList.remove('vz-theme-flash--active');
          setTimeout(function() { if (flash.parentNode) flash.parentNode.removeChild(flash); }, 300);
        }, 250);
      });
    });
  }

})();
